import React, { FunctionComponent } from 'react'

type StackdownProps = {
	//
}

const Stackdown: FunctionComponent<StackdownProps> = props => {
	return (
		<div className="stackdown">
			<a href="https://puzzlist.com/stackdown" aria-label="Play Stackdown" title="Play Stackdown">
				<svg width="100%" height="100%" viewBox="0 0 241 245" fill="none" xmlns="http://www.w3.org/2000/svg">
					<g filter="url(#filter0_d_0_1)">
						<path
							d="M147 11.6843C147 8.37061 149.686 5.68433 153 5.68433H181.526C184.84 5.68433 187.526 8.37062 187.526 11.6843V40.2107C187.526 43.5244 184.84 46.2106 181.526 46.2106H153C149.686 46.2106 147 43.5244 147 40.2106V11.6843Z"
							fill="#2A281E"
						/>
						<mask id="path-2-inside-1_0_1" fill="white">
							<path d="M147 7.99999C147 4.68628 149.686 2 153 2H181.526C184.84 2 187.526 4.68629 187.526 8V36.5263C187.526 39.84 184.84 42.5263 181.526 42.5263H153C149.686 42.5263 147 39.84 147 36.5263V7.99999Z" />
						</mask>
						<path
							d="M147 7.99999C147 4.68628 149.686 2 153 2H181.526C184.84 2 187.526 4.68629 187.526 8V36.5263C187.526 39.84 184.84 42.5263 181.526 42.5263H153C149.686 42.5263 147 39.84 147 36.5263V7.99999Z"
							fill="#c6b894"
							className="overlapped-tile-surface"
						/>
						<path
							d="M147 2H187.526H147ZM187.526 36.5263C187.526 40.3923 184.392 43.5263 180.526 43.5263H154C150.134 43.5263 147 40.3923 147 36.5263C147 39.2877 149.686 41.5263 153 41.5263H181.526C184.84 41.5263 187.526 39.2877 187.526 36.5263ZM147 42.5263V2V42.5263ZM187.526 2V42.5263V2Z"
							fill="#2A281E"
							mask="url(#path-2-inside-1_0_1)"
						/>
						<path
							d="M167.626 29.5664C166.981 29.5664 166.482 29.3904 166.13 29.0384C165.778 28.6717 165.602 28.1584 165.602 27.4984V15.7284C165.602 15.0537 165.778 14.5404 166.13 14.1884C166.482 13.8364 166.981 13.6604 167.626 13.6604C168.286 13.6604 168.785 13.8364 169.122 14.1884C169.474 14.5404 169.65 15.0537 169.65 15.7284V27.4984C169.65 28.1584 169.481 28.6717 169.144 29.0384C168.807 29.3904 168.301 29.5664 167.626 29.5664Z"
							fill="#2A281E"
						/>
					</g>
					<g filter="url(#filter1_d_0_1)">
						<path
							d="M195 59.6843C195 56.3706 197.686 53.6843 201 53.6843H229.526C232.84 53.6843 235.526 56.3706 235.526 59.6843V88.2107C235.526 91.5244 232.84 94.2106 229.526 94.2106H201C197.686 94.2106 195 91.5244 195 88.2106V59.6843Z"
							fill="#2A281E"
						/>
						<mask id="path-6-inside-2_0_1" fill="white">
							<path d="M195 56C195 52.6863 197.686 50 201 50H229.526C232.84 50 235.526 52.6863 235.526 56V84.5263C235.526 87.84 232.84 90.5263 229.526 90.5263H201C197.686 90.5263 195 87.84 195 84.5263V56Z" />
						</mask>
						<path
							d="M195 56C195 52.6863 197.686 50 201 50H229.526C232.84 50 235.526 52.6863 235.526 56V84.5263C235.526 87.84 232.84 90.5263 229.526 90.5263H201C197.686 90.5263 195 87.84 195 84.5263V56Z"
							fill="#c6b894"
							className="overlapped-tile-surface"
						/>
						<path
							d="M195 50H235.526H195ZM235.526 84.5263C235.526 88.3923 232.392 91.5263 228.526 91.5263H202C198.134 91.5263 195 88.3923 195 84.5263C195 87.2877 197.686 89.5263 201 89.5263H229.526C232.84 89.5263 235.526 87.2877 235.526 84.5263ZM195 90.5263V50V90.5263ZM235.526 50V90.5263V50Z"
							fill="#2A281E"
							mask="url(#path-6-inside-2_0_1)"
						/>
						<path
							d="M215.626 77.5664C214.981 77.5664 214.482 77.3904 214.13 77.0384C213.778 76.6717 213.602 76.1584 213.602 75.4984V63.7284C213.602 63.0537 213.778 62.5404 214.13 62.1884C214.482 61.8364 214.981 61.6604 215.626 61.6604C216.286 61.6604 216.785 61.8364 217.122 62.1884C217.474 62.5404 217.65 63.0537 217.65 63.7284V75.4984C217.65 76.1584 217.481 76.6717 217.144 77.0384C216.807 77.3904 216.301 77.5664 215.626 77.5664Z"
							fill="#2A281E"
						/>
					</g>
					<g filter="url(#filter2_d_0_1)">
						<path
							d="M3 59.6843C3 56.3706 5.68629 53.6843 9 53.6843H37.5263C40.84 53.6843 43.5263 56.3706 43.5263 59.6843V88.2107C43.5263 91.5244 40.84 94.2106 37.5263 94.2106H8.99999C5.68628 94.2106 3 91.5244 3 88.2106V59.6843Z"
							fill="#2A281E"
						/>
						<mask id="path-10-inside-3_0_1" fill="white">
							<path d="M3 56C3 52.6863 5.68629 50 9 50H37.5263C40.84 50 43.5263 52.6863 43.5263 56V84.5263C43.5263 87.84 40.84 90.5263 37.5263 90.5263H8.99999C5.68628 90.5263 3 87.84 3 84.5263V56Z" />
						</mask>
						<path
							d="M3 56C3 52.6863 5.68629 50 9 50H37.5263C40.84 50 43.5263 52.6863 43.5263 56V84.5263C43.5263 87.84 40.84 90.5263 37.5263 90.5263H8.99999C5.68628 90.5263 3 87.84 3 84.5263V56Z"
							fill="#c6b894"
							className="overlapped-tile-surface"
						/>
						<path
							d="M3 50H43.5263H3ZM43.5263 84.5263C43.5263 88.3923 40.3923 91.5263 36.5263 91.5263H10C6.13401 91.5263 3 88.3923 3 84.5263C3 87.2877 5.68629 89.5263 9 89.5263H37.5263C40.84 89.5263 43.5263 87.2877 43.5263 84.5263ZM3 90.5263V50V90.5263ZM43.5263 50V90.5263V50Z"
							fill="#2A281E"
							mask="url(#path-10-inside-3_0_1)"
						/>
						<path
							d="M23.6259 77.5664C22.9805 77.5664 22.4819 77.3904 22.1299 77.0384C21.7779 76.6717 21.6019 76.1584 21.6019 75.4984V63.7284C21.6019 63.0537 21.7779 62.5404 22.1299 62.1884C22.4819 61.8364 22.9805 61.6604 23.6259 61.6604C24.2859 61.6604 24.7845 61.8364 25.1219 62.1884C25.4739 62.5404 25.6499 63.0537 25.6499 63.7284V75.4984C25.6499 76.1584 25.4812 76.6717 25.1439 77.0384C24.8065 77.3904 24.3005 77.5664 23.6259 77.5664Z"
							fill="#2A281E"
						/>
					</g>
					<g filter="url(#filter3_d_0_1)">
						<path
							d="M51 11.6843C51 8.37061 53.6863 5.68433 57 5.68433H85.5263C88.84 5.68433 91.5263 8.37062 91.5263 11.6843V40.2107C91.5263 43.5244 88.84 46.2106 85.5263 46.2106H57C53.6863 46.2106 51 43.5244 51 40.2106V11.6843Z"
							fill="#2A281E"
						/>
						<mask id="path-14-inside-4_0_1" fill="white">
							<path d="M51 7.99999C51 4.68628 53.6863 2 57 2H85.5263C88.84 2 91.5263 4.68629 91.5263 8V36.5263C91.5263 39.84 88.84 42.5263 85.5263 42.5263H57C53.6863 42.5263 51 39.84 51 36.5263V7.99999Z" />
						</mask>
						<path
							d="M51 7.99999C51 4.68628 53.6863 2 57 2H85.5263C88.84 2 91.5263 4.68629 91.5263 8V36.5263C91.5263 39.84 88.84 42.5263 85.5263 42.5263H57C53.6863 42.5263 51 39.84 51 36.5263V7.99999Z"
							fill="#c6b894"
							className="overlapped-tile-surface"
						/>
						<path
							d="M51 2H91.5263H51ZM91.5263 36.5263C91.5263 40.3923 88.3923 43.5263 84.5263 43.5263H58C54.134 43.5263 51 40.3923 51 36.5263C51 39.2877 53.6863 41.5263 57 41.5263H85.5263C88.84 41.5263 91.5263 39.2877 91.5263 36.5263ZM51 42.5263V2V42.5263ZM91.5263 2V42.5263V2Z"
							fill="#2A281E"
							mask="url(#path-14-inside-4_0_1)"
						/>
						<path
							d="M72.7308 29.6104C70.9562 29.6104 69.4455 29.2804 68.1988 28.6204C66.9668 27.9604 66.0282 27.0364 65.3828 25.8484C64.7375 24.6604 64.4148 23.2744 64.4148 21.6904C64.4148 20.4584 64.6055 19.3511 64.9868 18.3684C65.3828 17.3711 65.9475 16.5204 66.6808 15.8164C67.4142 15.0977 68.3088 14.5551 69.3648 14.1884C70.4355 13.8071 71.6455 13.6164 72.9948 13.6164C73.7282 13.6164 74.4762 13.6897 75.2388 13.8364C76.0015 13.9684 76.7495 14.2251 77.4828 14.6064C77.8642 14.7824 78.1208 15.0317 78.2528 15.3544C78.3995 15.6624 78.4435 15.9924 78.3848 16.3444C78.3408 16.6817 78.2162 16.9971 78.0108 17.2904C77.8202 17.5691 77.5562 17.7597 77.2188 17.8624C76.8815 17.9504 76.5002 17.8991 76.0748 17.7084C75.6348 17.5031 75.1582 17.3491 74.6448 17.2464C74.1315 17.1291 73.5888 17.0704 73.0168 17.0704C72.0342 17.0704 71.2128 17.2464 70.5528 17.5984C69.9075 17.9504 69.4235 18.4711 69.1008 19.1604C68.7782 19.8497 68.6168 20.6931 68.6168 21.6904C68.6168 23.1864 68.9835 24.3157 69.7168 25.0784C70.4502 25.8411 71.5355 26.2224 72.9728 26.2224C73.4128 26.2224 73.8895 26.1784 74.4028 26.0904C74.9308 26.0024 75.4588 25.8777 75.9868 25.7164L75.2388 27.2344V23.4724H73.6988C73.2002 23.4724 72.8115 23.3477 72.5328 23.0984C72.2688 22.8491 72.1368 22.4971 72.1368 22.0424C72.1368 21.5877 72.2688 21.2431 72.5328 21.0084C72.8115 20.7591 73.2002 20.6344 73.6988 20.6344H76.9548C77.4682 20.6344 77.8568 20.7737 78.1208 21.0524C78.3995 21.3164 78.5388 21.7051 78.5388 22.2184V27.0804C78.5388 27.5204 78.4435 27.8944 78.2528 28.2024C78.0768 28.5104 77.7908 28.7304 77.3948 28.8624C76.7055 29.0971 75.9575 29.2804 75.1508 29.4124C74.3442 29.5444 73.5375 29.6104 72.7308 29.6104Z"
							fill="#2A281E"
						/>
					</g>
					<g filter="url(#filter4_d_0_1)">
						<path
							d="M195 107.684C195 104.371 197.686 101.684 201 101.684H229.526C232.84 101.684 235.526 104.371 235.526 107.684V136.211C235.526 139.524 232.84 142.211 229.526 142.211H201C197.686 142.211 195 139.524 195 136.211V107.684Z"
							fill="#2A281E"
						/>
						<mask id="path-18-inside-5_0_1" fill="white">
							<path d="M195 104C195 100.686 197.686 98 201 98H229.526C232.84 98 235.526 100.686 235.526 104V132.526C235.526 135.84 232.84 138.526 229.526 138.526H201C197.686 138.526 195 135.84 195 132.526V104Z" />
						</mask>
						<path
							d="M195 104C195 100.686 197.686 98 201 98H229.526C232.84 98 235.526 100.686 235.526 104V132.526C235.526 135.84 232.84 138.526 229.526 138.526H201C197.686 138.526 195 135.84 195 132.526V104Z"
							fill="#c6b894"
							className="overlapped-tile-surface"
						/>
						<path
							d="M195 98H235.526H195ZM235.526 132.526C235.526 136.392 232.392 139.526 228.526 139.526H202C198.134 139.526 195 136.392 195 132.526C195 135.288 197.686 137.526 201 137.526H229.526C232.84 137.526 235.526 135.288 235.526 132.526ZM195 138.526V98V138.526ZM235.526 98V138.526V98Z"
							fill="#2A281E"
							mask="url(#path-18-inside-5_0_1)"
						/>
						<path
							d="M215.626 125.566C214.98 125.566 214.482 125.39 214.13 125.038C213.778 124.672 213.602 124.166 213.602 123.52V113.158H210.148C209.605 113.158 209.187 113.019 208.894 112.74C208.615 112.447 208.476 112.036 208.476 111.508C208.476 110.966 208.615 110.555 208.894 110.276C209.187 109.998 209.605 109.858 210.148 109.858H221.104C221.646 109.858 222.057 109.998 222.336 110.276C222.629 110.555 222.776 110.966 222.776 111.508C222.776 112.036 222.629 112.447 222.336 112.74C222.057 113.019 221.646 113.158 221.104 113.158H217.65V123.52C217.65 124.166 217.481 124.672 217.144 125.038C216.806 125.39 216.3 125.566 215.626 125.566Z"
							fill="#2A281E"
						/>
					</g>
					<g filter="url(#filter5_d_0_1)">
						<path
							d="M147 203.684C147 200.371 149.686 197.684 153 197.684H181.526C184.84 197.684 187.526 200.371 187.526 203.684V232.211C187.526 235.524 184.84 238.211 181.526 238.211H153C149.686 238.211 147 235.524 147 232.211V203.684Z"
							fill="#2A281E"
						/>
						<mask id="path-22-inside-6_0_1" fill="white">
							<path d="M147 200C147 196.686 149.686 194 153 194H181.526C184.84 194 187.526 196.686 187.526 200V228.526C187.526 231.84 184.84 234.526 181.526 234.526H153C149.686 234.526 147 231.84 147 228.526V200Z" />
						</mask>
						<path
							d="M147 200C147 196.686 149.686 194 153 194H181.526C184.84 194 187.526 196.686 187.526 200V228.526C187.526 231.84 184.84 234.526 181.526 234.526H153C149.686 234.526 147 231.84 147 228.526V200Z"
							fill="#c6b894"
							className="overlapped-tile-surface"
						/>
						<path
							d="M147 194H187.526H147ZM187.526 228.526C187.526 232.392 184.392 235.526 180.526 235.526H154C150.134 235.526 147 232.392 147 228.526C147 231.288 149.686 233.526 153 233.526H181.526C184.84 233.526 187.526 231.288 187.526 228.526ZM147 234.526V194V234.526ZM187.526 194V234.526V194Z"
							fill="#2A281E"
							mask="url(#path-22-inside-6_0_1)"
						/>
						<path
							d="M169.287 221.61C167.571 221.61 166.097 221.28 164.865 220.62C163.633 219.96 162.687 219.029 162.027 217.826C161.382 216.624 161.059 215.216 161.059 213.602C161.059 212.4 161.243 211.307 161.609 210.324C161.991 209.342 162.533 208.498 163.237 207.794C163.956 207.09 164.821 206.555 165.833 206.188C166.86 205.807 168.011 205.616 169.287 205.616C169.962 205.616 170.659 205.697 171.377 205.858C172.111 206.005 172.756 206.232 173.313 206.54C173.724 206.76 174.01 207.039 174.171 207.376C174.333 207.714 174.384 208.058 174.325 208.41C174.281 208.762 174.157 209.078 173.951 209.356C173.746 209.635 173.482 209.826 173.159 209.928C172.837 210.016 172.485 209.965 172.103 209.774C171.663 209.569 171.223 209.415 170.783 209.312C170.358 209.195 169.911 209.136 169.441 209.136C168.532 209.136 167.769 209.312 167.153 209.664C166.552 210.002 166.097 210.5 165.789 211.16C165.481 211.82 165.327 212.634 165.327 213.602C165.327 214.57 165.481 215.392 165.789 216.066C166.097 216.726 166.552 217.232 167.153 217.584C167.769 217.922 168.532 218.09 169.441 218.09C169.823 218.09 170.233 218.046 170.673 217.958C171.113 217.856 171.546 217.702 171.971 217.496C172.411 217.306 172.8 217.254 173.137 217.342C173.489 217.43 173.768 217.606 173.973 217.87C174.193 218.134 174.333 218.442 174.391 218.794C174.45 219.132 174.399 219.469 174.237 219.806C174.091 220.144 173.827 220.415 173.445 220.62C172.932 220.928 172.294 221.17 171.531 221.346C170.783 221.522 170.035 221.61 169.287 221.61Z"
							fill="#2A281E"
						/>
					</g>
					<g filter="url(#filter6_d_0_1)">
						<path
							d="M195 155.684C195 152.371 197.686 149.684 201 149.684H229.526C232.84 149.684 235.526 152.371 235.526 155.684V184.211C235.526 187.524 232.84 190.211 229.526 190.211H201C197.686 190.211 195 187.524 195 184.211V155.684Z"
							fill="#2A281E"
						/>
						<mask id="path-26-inside-7_0_1" fill="white">
							<path d="M195 152C195 148.686 197.686 146 201 146H229.526C232.84 146 235.526 148.686 235.526 152V180.526C235.526 183.84 232.84 186.526 229.526 186.526H201C197.686 186.526 195 183.84 195 180.526V152Z" />
						</mask>
						<path
							d="M195 152C195 148.686 197.686 146 201 146H229.526C232.84 146 235.526 148.686 235.526 152V180.526C235.526 183.84 232.84 186.526 229.526 186.526H201C197.686 186.526 195 183.84 195 180.526V152Z"
							fill="#c6b894"
							className="overlapped-tile-surface"
						/>
						<path
							d="M195 146H235.526H195ZM235.526 180.526C235.526 184.392 232.392 187.526 228.526 187.526H202C198.134 187.526 195 184.392 195 180.526C195 183.288 197.686 185.526 201 185.526H229.526C232.84 185.526 235.526 183.288 235.526 180.526ZM195 186.526V146V186.526ZM235.526 146V186.526V146Z"
							fill="#2A281E"
							mask="url(#path-26-inside-7_0_1)"
						/>
						<path
							d="M217.287 173.61C215.571 173.61 214.097 173.28 212.865 172.62C211.633 171.96 210.687 171.029 210.027 169.826C209.382 168.624 209.059 167.216 209.059 165.602C209.059 164.4 209.243 163.307 209.609 162.324C209.991 161.342 210.533 160.498 211.237 159.794C211.956 159.09 212.821 158.555 213.833 158.188C214.86 157.807 216.011 157.616 217.287 157.616C217.962 157.616 218.659 157.697 219.377 157.858C220.111 158.005 220.756 158.232 221.313 158.54C221.724 158.76 222.01 159.039 222.171 159.376C222.333 159.714 222.384 160.058 222.325 160.41C222.281 160.762 222.157 161.078 221.951 161.356C221.746 161.635 221.482 161.826 221.159 161.928C220.837 162.016 220.485 161.965 220.103 161.774C219.663 161.569 219.223 161.415 218.783 161.312C218.358 161.195 217.911 161.136 217.441 161.136C216.532 161.136 215.769 161.312 215.153 161.664C214.552 162.002 214.097 162.5 213.789 163.16C213.481 163.82 213.327 164.634 213.327 165.602C213.327 166.57 213.481 167.392 213.789 168.066C214.097 168.726 214.552 169.232 215.153 169.584C215.769 169.922 216.532 170.09 217.441 170.09C217.823 170.09 218.233 170.046 218.673 169.958C219.113 169.856 219.546 169.702 219.971 169.496C220.411 169.306 220.8 169.254 221.137 169.342C221.489 169.43 221.768 169.606 221.973 169.87C222.193 170.134 222.333 170.442 222.391 170.794C222.45 171.132 222.399 171.469 222.237 171.806C222.091 172.144 221.827 172.415 221.445 172.62C220.932 172.928 220.294 173.17 219.531 173.346C218.783 173.522 218.035 173.61 217.287 173.61Z"
							fill="#2A281E"
						/>
					</g>
					<g filter="url(#filter7_d_0_1)">
						<path
							d="M3 107.684C3 104.371 5.68629 101.684 9 101.684H37.5263C40.84 101.684 43.5263 104.371 43.5263 107.684V136.211C43.5263 139.524 40.84 142.211 37.5263 142.211H8.99999C5.68628 142.211 3 139.524 3 136.211V107.684Z"
							fill="#2A281E"
						/>
						<mask id="path-30-inside-8_0_1" fill="white">
							<path d="M3 104C3 100.686 5.68629 98 9 98H37.5263C40.84 98 43.5263 100.686 43.5263 104V132.526C43.5263 135.84 40.84 138.526 37.5263 138.526H8.99999C5.68628 138.526 3 135.84 3 132.526V104Z" />
						</mask>
						<path
							d="M3 104C3 100.686 5.68629 98 9 98H37.5263C40.84 98 43.5263 100.686 43.5263 104V132.526C43.5263 135.84 40.84 138.526 37.5263 138.526H8.99999C5.68628 138.526 3 135.84 3 132.526V104Z"
							fill="#c6b894"
							className="overlapped-tile-surface"
						/>
						<path
							d="M3 98H43.5263H3ZM43.5263 132.526C43.5263 136.392 40.3923 139.526 36.5263 139.526H10C6.13401 139.526 3 136.392 3 132.526C3 135.288 5.68629 137.526 9 137.526H37.5263C40.84 137.526 43.5263 135.288 43.5263 132.526ZM3 138.526V98V138.526ZM43.5263 98V138.526V98Z"
							fill="#2A281E"
							mask="url(#path-30-inside-8_0_1)"
						/>
						<path
							d="M23.6255 125.566C22.9802 125.566 22.4815 125.39 22.1295 125.038C21.7775 124.672 21.6015 124.166 21.6015 123.52V113.158H18.1475C17.6048 113.158 17.1868 113.019 16.8935 112.74C16.6148 112.447 16.4755 112.036 16.4755 111.508C16.4755 110.966 16.6148 110.555 16.8935 110.276C17.1868 109.998 17.6048 109.858 18.1475 109.858H29.1035C29.6462 109.858 30.0568 109.998 30.3355 110.276C30.6288 110.555 30.7755 110.966 30.7755 111.508C30.7755 112.036 30.6288 112.447 30.3355 112.74C30.0568 113.019 29.6462 113.158 29.1035 113.158H25.6495V123.52C25.6495 124.166 25.4808 124.672 25.1435 125.038C24.8062 125.39 24.3002 125.566 23.6255 125.566Z"
							fill="#2A281E"
						/>
					</g>
					<g filter="url(#filter8_d_0_1)">
						<path
							d="M3 155.684C3 152.371 5.68629 149.684 9 149.684H37.5263C40.84 149.684 43.5263 152.371 43.5263 155.684V184.211C43.5263 187.524 40.84 190.211 37.5263 190.211H8.99999C5.68628 190.211 3 187.524 3 184.211V155.684Z"
							fill="#2A281E"
						/>
						<mask id="path-34-inside-9_0_1" fill="white">
							<path d="M3 152C3 148.686 5.68629 146 9 146H37.5263C40.84 146 43.5263 148.686 43.5263 152V180.526C43.5263 183.84 40.84 186.526 37.5263 186.526H8.99999C5.68628 186.526 3 183.84 3 180.526V152Z" />
						</mask>
						<path
							d="M3 152C3 148.686 5.68629 146 9 146H37.5263C40.84 146 43.5263 148.686 43.5263 152V180.526C43.5263 183.84 40.84 186.526 37.5263 186.526H8.99999C5.68628 186.526 3 183.84 3 180.526V152Z"
							fill="#c6b894"
							className="overlapped-tile-surface"
						/>
						<path
							d="M3 146H43.5263H3ZM43.5263 180.526C43.5263 184.392 40.3923 187.526 36.5263 187.526H10C6.13401 187.526 3 184.392 3 180.526C3 183.288 5.68629 185.526 9 185.526H37.5263C40.84 185.526 43.5263 183.288 43.5263 180.526ZM3 186.526V146V186.526ZM43.5263 146V186.526V146Z"
							fill="#2A281E"
							mask="url(#path-34-inside-9_0_1)"
						/>
						<path
							d="M25.2874 173.61C23.5714 173.61 22.0974 173.28 20.8654 172.62C19.6334 171.96 18.6874 171.029 18.0274 169.826C17.382 168.624 17.0594 167.216 17.0594 165.602C17.0594 164.4 17.2427 163.307 17.6094 162.324C17.9907 161.342 18.5334 160.498 19.2374 159.794C19.956 159.09 20.8214 158.555 21.8334 158.188C22.86 157.807 24.0114 157.616 25.2874 157.616C25.962 157.616 26.6587 157.697 27.3774 157.858C28.1107 158.005 28.756 158.232 29.3134 158.54C29.724 158.76 30.01 159.039 30.1714 159.376C30.3327 159.714 30.384 160.058 30.3254 160.41C30.2814 160.762 30.1567 161.078 29.9514 161.356C29.746 161.635 29.482 161.826 29.1594 161.928C28.8367 162.016 28.4847 161.965 28.1034 161.774C27.6634 161.569 27.2234 161.415 26.7834 161.312C26.358 161.195 25.9107 161.136 25.4414 161.136C24.532 161.136 23.7694 161.312 23.1534 161.664C22.552 162.002 22.0974 162.5 21.7894 163.16C21.4814 163.82 21.3274 164.634 21.3274 165.602C21.3274 166.57 21.4814 167.392 21.7894 168.066C22.0974 168.726 22.552 169.232 23.1534 169.584C23.7694 169.922 24.532 170.09 25.4414 170.09C25.8227 170.09 26.2334 170.046 26.6734 169.958C27.1134 169.856 27.546 169.702 27.9714 169.496C28.4114 169.306 28.8 169.254 29.1374 169.342C29.4894 169.43 29.768 169.606 29.9734 169.87C30.1934 170.134 30.3327 170.442 30.3914 170.794C30.45 171.132 30.3987 171.469 30.2374 171.806C30.0907 172.144 29.8267 172.415 29.4454 172.62C28.932 172.928 28.294 173.17 27.5314 173.346C26.7834 173.522 26.0354 173.61 25.2874 173.61Z"
							fill="#2A281E"
						/>
					</g>
					<g filter="url(#filter9_d_0_1)">
						<path
							d="M51 203.684C51 200.371 53.6863 197.684 57 197.684H85.5263C88.84 197.684 91.5263 200.371 91.5263 203.684V232.211C91.5263 235.524 88.84 238.211 85.5263 238.211H57C53.6863 238.211 51 235.524 51 232.211V203.684Z"
							fill="#2A281E"
						/>
						<mask id="path-38-inside-10_0_1" fill="white">
							<path d="M51 200C51 196.686 53.6863 194 57 194H85.5263C88.84 194 91.5263 196.686 91.5263 200V228.526C91.5263 231.84 88.84 234.526 85.5263 234.526H57C53.6863 234.526 51 231.84 51 228.526V200Z" />
						</mask>
						<path
							d="M51 200C51 196.686 53.6863 194 57 194H85.5263C88.84 194 91.5263 196.686 91.5263 200V228.526C91.5263 231.84 88.84 234.526 85.5263 234.526H57C53.6863 234.526 51 231.84 51 228.526V200Z"
							fill="#c6b894"
							className="overlapped-tile-surface"
						/>
						<path
							d="M51 194H91.5263H51ZM91.5263 228.526C91.5263 232.392 88.3923 235.526 84.5263 235.526H58C54.134 235.526 51 232.392 51 228.526C51 231.288 53.6863 233.526 57 233.526H85.5263C88.84 233.526 91.5263 231.288 91.5263 228.526ZM51 234.526V194V234.526ZM91.5263 194V234.526V194Z"
							fill="#2A281E"
							mask="url(#path-38-inside-10_0_1)"
						/>
						<path
							d="M68.3838 221.368C67.6944 221.368 67.1664 221.192 66.7998 220.84C66.4478 220.474 66.2718 219.953 66.2718 219.278V207.948C66.2718 207.274 66.4478 206.76 66.7998 206.408C67.1664 206.042 67.6944 205.858 68.3838 205.858H75.8418C76.3698 205.858 76.7658 205.99 77.0298 206.254C77.2938 206.518 77.4258 206.9 77.4258 207.398C77.4258 207.912 77.2938 208.308 77.0298 208.586C76.7658 208.85 76.3698 208.982 75.8418 208.982H70.1438V211.93H75.3578C75.8711 211.93 76.2598 212.062 76.5238 212.326C76.8024 212.59 76.9418 212.979 76.9418 213.492C76.9418 214.006 76.8024 214.394 76.5238 214.658C76.2598 214.922 75.8711 215.054 75.3578 215.054H70.1438V218.244H75.8418C76.3698 218.244 76.7658 218.384 77.0298 218.662C77.2938 218.926 77.4258 219.308 77.4258 219.806C77.4258 220.32 77.2938 220.708 77.0298 220.972C76.7658 221.236 76.3698 221.368 75.8418 221.368H68.3838Z"
							fill="#2A281E"
						/>
					</g>
					<g filter="url(#filter10_d_0_1)">
						<path
							d="M171 83.6843C171 80.3706 173.686 77.6843 177 77.6843H205.526C208.84 77.6843 211.526 80.3706 211.526 83.6843V112.211C211.526 115.524 208.84 118.211 205.526 118.211H177C173.686 118.211 171 115.524 171 112.211V83.6843Z"
							fill="#2A281E"
						/>
						<mask id="path-42-inside-11_0_1" fill="white">
							<path d="M171 80C171 76.6863 173.686 74 177 74H205.526C208.84 74 211.526 76.6863 211.526 80V108.526C211.526 111.84 208.84 114.526 205.526 114.526H177C173.686 114.526 171 111.84 171 108.526V80Z" />
						</mask>
						<path
							d="M171 80C171 76.6863 173.686 74 177 74H205.526C208.84 74 211.526 76.6863 211.526 80V108.526C211.526 111.84 208.84 114.526 205.526 114.526H177C173.686 114.526 171 111.84 171 108.526V80Z"
							fill="#c6b894"
							className="overlapped-tile-surface"
						/>
						<path
							d="M171 74H211.526H171ZM211.526 108.526C211.526 112.392 208.392 115.526 204.526 115.526H178C174.134 115.526 171 112.392 171 108.526C171 111.288 173.686 113.526 177 113.526H205.526C208.84 113.526 211.526 111.288 211.526 108.526ZM171 114.526V74V114.526ZM211.526 74V114.526V74Z"
							fill="#2A281E"
							mask="url(#path-42-inside-11_0_1)"
						/>
						<path
							d="M185.177 101.566C184.59 101.566 184.136 101.405 183.813 101.082C183.505 100.76 183.351 100.305 183.351 99.7184V87.5084C183.351 86.9071 183.52 86.4524 183.857 86.1444C184.194 85.8217 184.671 85.6604 185.287 85.6604C185.8 85.6604 186.204 85.7631 186.497 85.9684C186.805 86.1591 187.084 86.4817 187.333 86.9364L192.063 95.4284H191.293L196.001 86.9364C196.265 86.4817 196.544 86.1591 196.837 85.9684C197.145 85.7631 197.556 85.6604 198.069 85.6604C198.656 85.6604 199.103 85.8217 199.411 86.1444C199.734 86.4524 199.895 86.9071 199.895 87.5084V99.7184C199.895 100.305 199.741 100.76 199.433 101.082C199.125 101.405 198.67 101.566 198.069 101.566C197.482 101.566 197.028 101.405 196.705 101.082C196.397 100.76 196.243 100.305 196.243 99.7184V92.1504H196.705L193.163 98.3104C192.958 98.6331 192.738 98.8751 192.503 99.0364C192.283 99.1977 191.982 99.2784 191.601 99.2784C191.234 99.2784 190.934 99.1977 190.699 99.0364C190.464 98.8751 190.252 98.6331 190.061 98.3104L186.497 92.1284H187.003V99.7184C187.003 100.305 186.849 100.76 186.541 101.082C186.233 101.405 185.778 101.566 185.177 101.566Z"
							fill="#2A281E"
						/>
					</g>
					<g filter="url(#filter11_d_0_1)">
						<path
							d="M27 83.6843C27 80.3706 29.6863 77.6843 33 77.6843H61.5263C64.84 77.6843 67.5263 80.3706 67.5263 83.6843V112.211C67.5263 115.524 64.84 118.211 61.5263 118.211H33C29.6863 118.211 27 115.524 27 112.211V83.6843Z"
							fill="#2A281E"
						/>
						<mask id="path-46-inside-12_0_1" fill="white">
							<path d="M27 80C27 76.6863 29.6863 74 33 74H61.5263C64.84 74 67.5263 76.6863 67.5263 80V108.526C67.5263 111.84 64.84 114.526 61.5263 114.526H33C29.6863 114.526 27 111.84 27 108.526V80Z" />
						</mask>
						<path
							d="M27 80C27 76.6863 29.6863 74 33 74H61.5263C64.84 74 67.5263 76.6863 67.5263 80V108.526C67.5263 111.84 64.84 114.526 61.5263 114.526H33C29.6863 114.526 27 111.84 27 108.526V80Z"
							fill="#c6b894"
							className="overlapped-tile-surface"
						/>
						<path
							d="M27 74H67.5263H27ZM67.5263 108.526C67.5263 112.392 64.3923 115.526 60.5263 115.526H34C30.134 115.526 27 112.392 27 108.526C27 111.288 29.6863 113.526 33 113.526H61.5263C64.84 113.526 67.5263 111.288 67.5263 108.526ZM27 114.526V74V114.526ZM67.5263 74V114.526V74Z"
							fill="#2A281E"
							mask="url(#path-46-inside-12_0_1)"
						/>
						<path
							d="M41.1769 101.566C40.5903 101.566 40.1356 101.405 39.8129 101.082C39.5049 100.76 39.3509 100.305 39.3509 99.7184V87.5084C39.3509 86.9071 39.5196 86.4524 39.8569 86.1444C40.1943 85.8217 40.6709 85.6604 41.2869 85.6604C41.8003 85.6604 42.2036 85.7631 42.4969 85.9684C42.8049 86.1591 43.0836 86.4817 43.3329 86.9364L48.0629 95.4284H47.2929L52.0009 86.9364C52.2649 86.4817 52.5436 86.1591 52.8369 85.9684C53.1449 85.7631 53.5556 85.6604 54.0689 85.6604C54.6556 85.6604 55.1029 85.8217 55.4109 86.1444C55.7336 86.4524 55.8949 86.9071 55.8949 87.5084V99.7184C55.8949 100.305 55.7409 100.76 55.4329 101.082C55.1249 101.405 54.6703 101.566 54.0689 101.566C53.4823 101.566 53.0276 101.405 52.7049 101.082C52.3969 100.76 52.2429 100.305 52.2429 99.7184V92.1504H52.7049L49.1629 98.3104C48.9576 98.6331 48.7376 98.8751 48.5029 99.0364C48.2829 99.1977 47.9823 99.2784 47.6009 99.2784C47.2343 99.2784 46.9336 99.1977 46.6989 99.0364C46.4643 98.8751 46.2516 98.6331 46.0609 98.3104L42.4969 92.1284H43.0029V99.7184C43.0029 100.305 42.8489 100.76 42.5409 101.082C42.2329 101.405 41.7783 101.566 41.1769 101.566Z"
							fill="#2A281E"
						/>
					</g>
					<g filter="url(#filter12_d_0_1)">
						<path
							d="M123 35.6843C123 32.3706 125.686 29.6843 129 29.6843H157.526C160.84 29.6843 163.526 32.3706 163.526 35.6843V64.2107C163.526 67.5244 160.84 70.2106 157.526 70.2106H129C125.686 70.2106 123 67.5244 123 64.2106V35.6843Z"
							fill="#2A281E"
						/>
						<mask id="path-50-inside-13_0_1" fill="white">
							<path d="M123 32C123 28.6863 125.686 26 129 26H157.526C160.84 26 163.526 28.6863 163.526 32V60.5263C163.526 63.84 160.84 66.5263 157.526 66.5263H129C125.686 66.5263 123 63.84 123 60.5263V32Z" />
						</mask>
						<path
							d="M123 32C123 28.6863 125.686 26 129 26H157.526C160.84 26 163.526 28.6863 163.526 32V60.5263C163.526 63.84 160.84 66.5263 157.526 66.5263H129C125.686 66.5263 123 63.84 123 60.5263V32Z"
							fill="#c6b894"
							className="overlapped-tile-surface"
						/>
						<path
							d="M123 26H163.526H123ZM163.526 60.5263C163.526 64.3923 160.392 67.5263 156.526 67.5263H130C126.134 67.5263 123 64.3923 123 60.5263C123 63.2877 125.686 65.5263 129 65.5263H157.526C160.84 65.5263 163.526 63.2877 163.526 60.5263ZM123 66.5263V26V66.5263ZM163.526 26V66.5263V26Z"
							fill="#2A281E"
							mask="url(#path-50-inside-13_0_1)"
						/>
						<path
							d="M137.177 53.5664C136.59 53.5664 136.136 53.4051 135.813 53.0824C135.505 52.7597 135.351 52.3051 135.351 51.7184V39.5084C135.351 38.9071 135.52 38.4524 135.857 38.1444C136.194 37.8217 136.671 37.6604 137.287 37.6604C137.8 37.6604 138.204 37.7631 138.497 37.9684C138.805 38.1591 139.084 38.4817 139.333 38.9364L144.063 47.4284H143.293L148.001 38.9364C148.265 38.4817 148.544 38.1591 148.837 37.9684C149.145 37.7631 149.556 37.6604 150.069 37.6604C150.656 37.6604 151.103 37.8217 151.411 38.1444C151.734 38.4524 151.895 38.9071 151.895 39.5084V51.7184C151.895 52.3051 151.741 52.7597 151.433 53.0824C151.125 53.4051 150.67 53.5664 150.069 53.5664C149.482 53.5664 149.028 53.4051 148.705 53.0824C148.397 52.7597 148.243 52.3051 148.243 51.7184V44.1504H148.705L145.163 50.3104C144.958 50.6331 144.738 50.8751 144.503 51.0364C144.283 51.1977 143.982 51.2784 143.601 51.2784C143.234 51.2784 142.934 51.1977 142.699 51.0364C142.464 50.8751 142.252 50.6331 142.061 50.3104L138.497 44.1284H139.003V51.7184C139.003 52.3051 138.849 52.7597 138.541 53.0824C138.233 53.4051 137.778 53.5664 137.177 53.5664Z"
							fill="#2A281E"
						/>
					</g>
					<g filter="url(#filter13_d_0_1)">
						<path
							d="M75 35.6843C75 32.3706 77.6863 29.6843 81 29.6843H109.526C112.84 29.6843 115.526 32.3706 115.526 35.6843V64.2107C115.526 67.5244 112.84 70.2106 109.526 70.2106H81C77.6863 70.2106 75 67.5244 75 64.2106V35.6843Z"
							fill="#2A281E"
						/>
						<mask id="path-54-inside-14_0_1" fill="white">
							<path d="M75 32C75 28.6863 77.6863 26 81 26H109.526C112.84 26 115.526 28.6863 115.526 32V60.5263C115.526 63.84 112.84 66.5263 109.526 66.5263H81C77.6863 66.5263 75 63.84 75 60.5263V32Z" />
						</mask>
						<path
							d="M75 32C75 28.6863 77.6863 26 81 26H109.526C112.84 26 115.526 28.6863 115.526 32V60.5263C115.526 63.84 112.84 66.5263 109.526 66.5263H81C77.6863 66.5263 75 63.84 75 60.5263V32Z"
							fill="#c6b894"
							className="overlapped-tile-surface"
						/>
						<path
							d="M75 26H115.526H75ZM115.526 60.5263C115.526 64.3923 112.392 67.5263 108.526 67.5263H82C78.134 67.5263 75 64.3923 75 60.5263C75 63.2877 77.6863 65.5263 81 65.5263H109.526C112.84 65.5263 115.526 63.2877 115.526 60.5263ZM75 66.5263V26V66.5263ZM115.526 26V66.5263V26Z"
							fill="#2A281E"
							mask="url(#path-54-inside-14_0_1)"
						/>
						<path
							d="M89.1769 53.5664C88.5903 53.5664 88.1356 53.4051 87.8129 53.0824C87.5049 52.7597 87.3509 52.3051 87.3509 51.7184V39.5084C87.3509 38.9071 87.5196 38.4524 87.8569 38.1444C88.1943 37.8217 88.6709 37.6604 89.2869 37.6604C89.8003 37.6604 90.2036 37.7631 90.4969 37.9684C90.8049 38.1591 91.0836 38.4817 91.3329 38.9364L96.0629 47.4284H95.2929L100.001 38.9364C100.265 38.4817 100.544 38.1591 100.837 37.9684C101.145 37.7631 101.556 37.6604 102.069 37.6604C102.656 37.6604 103.103 37.8217 103.411 38.1444C103.734 38.4524 103.895 38.9071 103.895 39.5084V51.7184C103.895 52.3051 103.741 52.7597 103.433 53.0824C103.125 53.4051 102.67 53.5664 102.069 53.5664C101.482 53.5664 101.028 53.4051 100.705 53.0824C100.397 52.7597 100.243 52.3051 100.243 51.7184V44.1504H100.705L97.1629 50.3104C96.9576 50.6331 96.7376 50.8751 96.5029 51.0364C96.2829 51.1977 95.9823 51.2784 95.6009 51.2784C95.2343 51.2784 94.9336 51.1977 94.6989 51.0364C94.4643 50.8751 94.2516 50.6331 94.0609 50.3104L90.4969 44.1284H91.0029V51.7184C91.0029 52.3051 90.8489 52.7597 90.5409 53.0824C90.2329 53.4051 89.7783 53.5664 89.1769 53.5664Z"
							fill="#2A281E"
						/>
					</g>
					<g filter="url(#filter14_d_0_1)">
						<path
							d="M123 179.684C123 176.371 125.686 173.684 129 173.684H157.526C160.84 173.684 163.526 176.371 163.526 179.684V208.211C163.526 211.524 160.84 214.211 157.526 214.211H129C125.686 214.211 123 211.524 123 208.211V179.684Z"
							fill="#2A281E"
						/>
						<mask id="path-58-inside-15_0_1" fill="white">
							<path d="M123 176C123 172.686 125.686 170 129 170H157.526C160.84 170 163.526 172.686 163.526 176V204.526C163.526 207.84 160.84 210.526 157.526 210.526H129C125.686 210.526 123 207.84 123 204.526V176Z" />
						</mask>
						<path
							d="M123 176C123 172.686 125.686 170 129 170H157.526C160.84 170 163.526 172.686 163.526 176V204.526C163.526 207.84 160.84 210.526 157.526 210.526H129C125.686 210.526 123 207.84 123 204.526V176Z"
							fill="#c6b894"
							className="overlapped-tile-surface"
						/>
						<path
							d="M123 170H163.526H123ZM163.526 204.526C163.526 208.392 160.392 211.526 156.526 211.526H130C126.134 211.526 123 208.392 123 204.526C123 207.288 125.686 209.526 129 209.526H157.526C160.84 209.526 163.526 207.288 163.526 204.526ZM123 210.526V170V210.526ZM163.526 170V210.526V170Z"
							fill="#2A281E"
							mask="url(#path-58-inside-15_0_1)"
						/>
						<path
							d="M137.177 197.566C136.59 197.566 136.136 197.405 135.813 197.082C135.505 196.76 135.351 196.305 135.351 195.718V183.508C135.351 182.907 135.52 182.452 135.857 182.144C136.194 181.822 136.671 181.66 137.287 181.66C137.8 181.66 138.204 181.763 138.497 181.968C138.805 182.159 139.084 182.482 139.333 182.936L144.063 191.428H143.293L148.001 182.936C148.265 182.482 148.544 182.159 148.837 181.968C149.145 181.763 149.556 181.66 150.069 181.66C150.656 181.66 151.103 181.822 151.411 182.144C151.734 182.452 151.895 182.907 151.895 183.508V195.718C151.895 196.305 151.741 196.76 151.433 197.082C151.125 197.405 150.67 197.566 150.069 197.566C149.482 197.566 149.028 197.405 148.705 197.082C148.397 196.76 148.243 196.305 148.243 195.718V188.15H148.705L145.163 194.31C144.958 194.633 144.738 194.875 144.503 195.036C144.283 195.198 143.982 195.278 143.601 195.278C143.234 195.278 142.934 195.198 142.699 195.036C142.464 194.875 142.252 194.633 142.061 194.31L138.497 188.128H139.003V195.718C139.003 196.305 138.849 196.76 138.541 197.082C138.233 197.405 137.778 197.566 137.177 197.566Z"
							fill="#2A281E"
						/>
					</g>
					<g filter="url(#filter15_d_0_1)">
						<path
							d="M75 179.684C75 176.371 77.6863 173.684 81 173.684H109.526C112.84 173.684 115.526 176.371 115.526 179.684V208.211C115.526 211.524 112.84 214.211 109.526 214.211H81C77.6863 214.211 75 211.524 75 208.211V179.684Z"
							fill="#2A281E"
						/>
						<mask id="path-62-inside-16_0_1" fill="white">
							<path d="M75 176C75 172.686 77.6863 170 81 170H109.526C112.84 170 115.526 172.686 115.526 176V204.526C115.526 207.84 112.84 210.526 109.526 210.526H81C77.6863 210.526 75 207.84 75 204.526V176Z" />
						</mask>
						<path
							d="M75 176C75 172.686 77.6863 170 81 170H109.526C112.84 170 115.526 172.686 115.526 176V204.526C115.526 207.84 112.84 210.526 109.526 210.526H81C77.6863 210.526 75 207.84 75 204.526V176Z"
							fill="#c6b894"
							className="overlapped-tile-surface"
						/>
						<path
							d="M75 170H115.526H75ZM115.526 204.526C115.526 208.392 112.392 211.526 108.526 211.526H82C78.134 211.526 75 208.392 75 204.526C75 207.288 77.6863 209.526 81 209.526H109.526C112.84 209.526 115.526 207.288 115.526 204.526ZM75 210.526V170V210.526ZM115.526 170V210.526V170Z"
							fill="#2A281E"
							mask="url(#path-62-inside-16_0_1)"
						/>
						<path
							d="M89.1769 197.566C88.5903 197.566 88.1356 197.405 87.8129 197.082C87.5049 196.76 87.3509 196.305 87.3509 195.718V183.508C87.3509 182.907 87.5196 182.452 87.8569 182.144C88.1943 181.822 88.6709 181.66 89.2869 181.66C89.8003 181.66 90.2036 181.763 90.4969 181.968C90.8049 182.159 91.0836 182.482 91.3329 182.936L96.0629 191.428H95.2929L100.001 182.936C100.265 182.482 100.544 182.159 100.837 181.968C101.145 181.763 101.556 181.66 102.069 181.66C102.656 181.66 103.103 181.822 103.411 182.144C103.734 182.452 103.895 182.907 103.895 183.508V195.718C103.895 196.305 103.741 196.76 103.433 197.082C103.125 197.405 102.67 197.566 102.069 197.566C101.482 197.566 101.028 197.405 100.705 197.082C100.397 196.76 100.243 196.305 100.243 195.718V188.15H100.705L97.1629 194.31C96.9576 194.633 96.7376 194.875 96.5029 195.036C96.2829 195.198 95.9823 195.278 95.6009 195.278C95.2343 195.278 94.9336 195.198 94.6989 195.036C94.4643 194.875 94.2516 194.633 94.0609 194.31L90.4969 188.128H91.0029V195.718C91.0029 196.305 90.8489 196.76 90.5409 197.082C90.2329 197.405 89.7783 197.566 89.1769 197.566Z"
							fill="#2A281E"
						/>
					</g>
					<g filter="url(#filter16_d_0_1)">
						<path
							d="M171 131.684C171 128.371 173.686 125.684 177 125.684H205.526C208.84 125.684 211.526 128.371 211.526 131.684V160.211C211.526 163.524 208.84 166.211 205.526 166.211H177C173.686 166.211 171 163.524 171 160.211V131.684Z"
							fill="#2A281E"
						/>
						<mask id="path-66-inside-17_0_1" fill="white">
							<path d="M171 128C171 124.686 173.686 122 177 122H205.526C208.84 122 211.526 124.686 211.526 128V156.526C211.526 159.84 208.84 162.526 205.526 162.526H177C173.686 162.526 171 159.84 171 156.526V128Z" />
						</mask>
						<path
							d="M171 128C171 124.686 173.686 122 177 122H205.526C208.84 122 211.526 124.686 211.526 128V156.526C211.526 159.84 208.84 162.526 205.526 162.526H177C173.686 162.526 171 159.84 171 156.526V128Z"
							fill="#c6b894"
							className="overlapped-tile-surface"
						/>
						<path
							d="M171 122H211.526H171ZM211.526 156.526C211.526 160.392 208.392 163.526 204.526 163.526H178C174.134 163.526 171 160.392 171 156.526C171 159.288 173.686 161.526 177 161.526H205.526C208.84 161.526 211.526 159.288 211.526 156.526ZM171 162.526V122V162.526ZM211.526 122V162.526V122Z"
							fill="#2A281E"
							mask="url(#path-66-inside-17_0_1)"
						/>
						<path
							d="M192.731 149.61C190.956 149.61 189.446 149.28 188.199 148.62C186.967 147.96 186.028 147.036 185.383 145.848C184.738 144.66 184.415 143.274 184.415 141.69C184.415 140.458 184.606 139.351 184.987 138.368C185.383 137.371 185.948 136.52 186.681 135.816C187.414 135.098 188.309 134.555 189.365 134.188C190.436 133.807 191.646 133.616 192.995 133.616C193.728 133.616 194.476 133.69 195.239 133.836C196.002 133.968 196.75 134.225 197.483 134.606C197.864 134.782 198.121 135.032 198.253 135.354C198.4 135.662 198.444 135.992 198.385 136.344C198.341 136.682 198.216 136.997 198.011 137.29C197.82 137.569 197.556 137.76 197.219 137.862C196.882 137.95 196.5 137.899 196.075 137.708C195.635 137.503 195.158 137.349 194.645 137.246C194.132 137.129 193.589 137.07 193.017 137.07C192.034 137.07 191.213 137.246 190.553 137.598C189.908 137.95 189.424 138.471 189.101 139.16C188.778 139.85 188.617 140.693 188.617 141.69C188.617 143.186 188.984 144.316 189.717 145.078C190.45 145.841 191.536 146.222 192.973 146.222C193.413 146.222 193.89 146.178 194.403 146.09C194.931 146.002 195.459 145.878 195.987 145.716L195.239 147.234V143.472H193.699C193.2 143.472 192.812 143.348 192.533 143.098C192.269 142.849 192.137 142.497 192.137 142.042C192.137 141.588 192.269 141.243 192.533 141.008C192.812 140.759 193.2 140.634 193.699 140.634H196.955C197.468 140.634 197.857 140.774 198.121 141.052C198.4 141.316 198.539 141.705 198.539 142.218V147.08C198.539 147.52 198.444 147.894 198.253 148.202C198.077 148.51 197.791 148.73 197.395 148.862C196.706 149.097 195.958 149.28 195.151 149.412C194.344 149.544 193.538 149.61 192.731 149.61Z"
							fill="#2A281E"
						/>
					</g>
					<g filter="url(#filter17_d_0_1)">
						<path
							d="M27 131.684C27 128.371 29.6863 125.684 33 125.684H61.5263C64.84 125.684 67.5263 128.371 67.5263 131.684V160.211C67.5263 163.524 64.84 166.211 61.5263 166.211H33C29.6863 166.211 27 163.524 27 160.211V131.684Z"
							fill="#2A281E"
						/>
						<mask id="path-70-inside-18_0_1" fill="white">
							<path d="M27 128C27 124.686 29.6863 122 33 122H61.5263C64.84 122 67.5263 124.686 67.5263 128V156.526C67.5263 159.84 64.84 162.526 61.5263 162.526H33C29.6863 162.526 27 159.84 27 156.526V128Z" />
						</mask>
						<path
							d="M27 128C27 124.686 29.6863 122 33 122H61.5263C64.84 122 67.5263 124.686 67.5263 128V156.526C67.5263 159.84 64.84 162.526 61.5263 162.526H33C29.6863 162.526 27 159.84 27 156.526V128Z"
							fill="#c6b894"
							className="overlapped-tile-surface"
						/>
						<path
							d="M27 122H67.5263H27ZM67.5263 156.526C67.5263 160.392 64.3923 163.526 60.5263 163.526H34C30.134 163.526 27 160.392 27 156.526C27 159.288 29.6863 161.526 33 161.526H61.5263C64.84 161.526 67.5263 159.288 67.5263 156.526ZM27 162.526V122V162.526ZM67.5263 122V162.526V122Z"
							fill="#2A281E"
							mask="url(#path-70-inside-18_0_1)"
						/>
						<path
							d="M48.7308 149.61C46.9562 149.61 45.4455 149.28 44.1988 148.62C42.9668 147.96 42.0282 147.036 41.3828 145.848C40.7375 144.66 40.4148 143.274 40.4148 141.69C40.4148 140.458 40.6055 139.351 40.9868 138.368C41.3828 137.371 41.9475 136.52 42.6808 135.816C43.4142 135.098 44.3088 134.555 45.3648 134.188C46.4355 133.807 47.6455 133.616 48.9948 133.616C49.7282 133.616 50.4762 133.69 51.2388 133.836C52.0015 133.968 52.7495 134.225 53.4828 134.606C53.8642 134.782 54.1208 135.032 54.2528 135.354C54.3995 135.662 54.4435 135.992 54.3848 136.344C54.3408 136.682 54.2162 136.997 54.0108 137.29C53.8202 137.569 53.5562 137.76 53.2188 137.862C52.8815 137.95 52.5002 137.899 52.0748 137.708C51.6348 137.503 51.1582 137.349 50.6448 137.246C50.1315 137.129 49.5888 137.07 49.0168 137.07C48.0342 137.07 47.2128 137.246 46.5528 137.598C45.9075 137.95 45.4235 138.471 45.1008 139.16C44.7782 139.85 44.6168 140.693 44.6168 141.69C44.6168 143.186 44.9835 144.316 45.7168 145.078C46.4502 145.841 47.5355 146.222 48.9728 146.222C49.4128 146.222 49.8895 146.178 50.4028 146.09C50.9308 146.002 51.4588 145.878 51.9868 145.716L51.2388 147.234V143.472H49.6988C49.2002 143.472 48.8115 143.348 48.5328 143.098C48.2688 142.849 48.1368 142.497 48.1368 142.042C48.1368 141.588 48.2688 141.243 48.5328 141.008C48.8115 140.759 49.2002 140.634 49.6988 140.634H52.9548C53.4682 140.634 53.8568 140.774 54.1208 141.052C54.3995 141.316 54.5388 141.705 54.5388 142.218V147.08C54.5388 147.52 54.4435 147.894 54.2528 148.202C54.0768 148.51 53.7908 148.73 53.3948 148.862C52.7055 149.097 51.9575 149.28 51.1508 149.412C50.3442 149.544 49.5375 149.61 48.7308 149.61Z"
							fill="#2A281E"
						/>
					</g>
					<g filter="url(#filter18_d_0_1)">
						<path
							d="M147 59.6843C147 56.3706 149.686 53.6843 153 53.6843H181.526C184.84 53.6843 187.526 56.3706 187.526 59.6843V88.2107C187.526 91.5244 184.84 94.2106 181.526 94.2106H153C149.686 94.2106 147 91.5244 147 88.2106V59.6843Z"
							fill="#2A281E"
						/>
						<mask id="path-74-inside-19_0_1" fill="white">
							<path d="M147 56C147 52.6863 149.686 50 153 50H181.526C184.84 50 187.526 52.6863 187.526 56V84.5263C187.526 87.84 184.84 90.5263 181.526 90.5263H153C149.686 90.5263 147 87.84 147 84.5263V56Z" />
						</mask>
						<path
							d="M147 56C147 52.6863 149.686 50 153 50H181.526C184.84 50 187.526 52.6863 187.526 56V84.5263C187.526 87.84 184.84 90.5263 181.526 90.5263H153C149.686 90.5263 147 87.84 147 84.5263V56Z"
							fill="#c6b894"
							className="overlapped-tile-surface"
						/>
						<path
							d="M147 50H187.526H147ZM187.526 84.5263C187.526 88.3923 184.392 91.5263 180.526 91.5263H154C150.134 91.5263 147 88.3923 147 84.5263C147 87.2877 149.686 89.5263 153 89.5263H181.526C184.84 89.5263 187.526 87.2877 187.526 84.5263ZM147 90.5263V50V90.5263ZM187.526 50V90.5263V50Z"
							fill="#2A281E"
							mask="url(#path-74-inside-19_0_1)"
						/>
						<path
							d="M167.626 77.5664C166.981 77.5664 166.482 77.3904 166.13 77.0384C165.778 76.6717 165.602 76.1584 165.602 75.4984V63.7284C165.602 63.0537 165.778 62.5404 166.13 62.1884C166.482 61.8364 166.981 61.6604 167.626 61.6604C168.286 61.6604 168.785 61.8364 169.122 62.1884C169.474 62.5404 169.65 63.0537 169.65 63.7284V75.4984C169.65 76.1584 169.481 76.6717 169.144 77.0384C168.807 77.3904 168.301 77.5664 167.626 77.5664Z"
							fill="#2A281E"
						/>
					</g>
					<g filter="url(#filter19_d_0_1)">
						<path
							d="M99 59.6843C99 56.3706 101.686 53.6843 105 53.6843H133.526C136.84 53.6843 139.526 56.3706 139.526 59.6843V88.2107C139.526 91.5244 136.84 94.2106 133.526 94.2106H105C101.686 94.2106 99 91.5244 99 88.2106V59.6843Z"
							fill="#2A281E"
						/>
						<mask id="path-78-inside-20_0_1" fill="white">
							<path d="M99 56C99 52.6863 101.686 50 105 50H133.526C136.84 50 139.526 52.6863 139.526 56V84.5263C139.526 87.84 136.84 90.5263 133.526 90.5263H105C101.686 90.5263 99 87.84 99 84.5263V56Z" />
						</mask>
						<path
							d="M99 56C99 52.6863 101.686 50 105 50H133.526C136.84 50 139.526 52.6863 139.526 56V84.5263C139.526 87.84 136.84 90.5263 133.526 90.5263H105C101.686 90.5263 99 87.84 99 84.5263V56Z"
							fill="#c6b894"
							className="overlapped-tile-surface"
						/>
						<path
							d="M99 50H139.526H99ZM139.526 84.5263C139.526 88.3923 136.392 91.5263 132.526 91.5263H106C102.134 91.5263 99 88.3923 99 84.5263C99 87.2877 101.686 89.5263 105 89.5263H133.526C136.84 89.5263 139.526 87.2877 139.526 84.5263ZM99 90.5263V50V90.5263ZM139.526 50V90.5263V50Z"
							fill="#2A281E"
							mask="url(#path-78-inside-20_0_1)"
						/>
						<path
							d="M115.222 77.5664C114.576 77.5664 114.078 77.3904 113.726 77.0384C113.374 76.6717 113.198 76.1657 113.198 75.5204V63.7064C113.198 63.0317 113.374 62.5257 113.726 62.1884C114.078 61.8364 114.576 61.6604 115.222 61.6604C115.882 61.6604 116.38 61.8364 116.718 62.1884C117.07 62.5257 117.246 63.0317 117.246 63.7064V68.5024H117.29L122.636 62.6064C122.914 62.3131 123.208 62.0857 123.516 61.9244C123.838 61.7484 124.198 61.6604 124.594 61.6604C125.21 61.6604 125.65 61.8217 125.914 62.1444C126.192 62.4524 126.317 62.8191 126.288 63.2444C126.273 63.6551 126.104 64.0364 125.782 64.3884L120.458 70.0424V68.3924L126.046 74.7064C126.427 75.1317 126.618 75.5717 126.618 76.0264C126.618 76.4664 126.464 76.8331 126.156 77.1264C125.862 77.4197 125.422 77.5664 124.836 77.5664C124.337 77.5664 123.934 77.4711 123.626 77.2804C123.332 77.0751 123.01 76.7744 122.658 76.3784L117.29 70.3724H117.246V75.5204C117.246 76.1657 117.077 76.6717 116.74 77.0384C116.402 77.3904 115.896 77.5664 115.222 77.5664Z"
							fill="#2A281E"
						/>
					</g>
					<g filter="url(#filter20_d_0_1)">
						<path
							d="M51 59.6843C51 56.3706 53.6863 53.6843 57 53.6843H85.5263C88.84 53.6843 91.5263 56.3706 91.5263 59.6843V88.2107C91.5263 91.5244 88.84 94.2106 85.5263 94.2106H57C53.6863 94.2106 51 91.5244 51 88.2106V59.6843Z"
							fill="#2A281E"
						/>
						<mask id="path-82-inside-21_0_1" fill="white">
							<path d="M51 56C51 52.6863 53.6863 50 57 50H85.5263C88.84 50 91.5263 52.6863 91.5263 56V84.5263C91.5263 87.84 88.84 90.5263 85.5263 90.5263H57C53.6863 90.5263 51 87.84 51 84.5263V56Z" />
						</mask>
						<path
							d="M51 56C51 52.6863 53.6863 50 57 50H85.5263C88.84 50 91.5263 52.6863 91.5263 56V84.5263C91.5263 87.84 88.84 90.5263 85.5263 90.5263H57C53.6863 90.5263 51 87.84 51 84.5263V56Z"
							fill="#c6b894"
							className="overlapped-tile-surface"
						/>
						<path
							d="M51 50H91.5263H51ZM91.5263 84.5263C91.5263 88.3923 88.3923 91.5263 84.5263 91.5263H58C54.134 91.5263 51 88.3923 51 84.5263C51 87.2877 53.6863 89.5263 57 89.5263H85.5263C88.84 89.5263 91.5263 87.2877 91.5263 84.5263ZM51 90.5263V50V90.5263ZM91.5263 50V90.5263V50Z"
							fill="#2A281E"
							mask="url(#path-82-inside-21_0_1)"
						/>
						<path
							d="M72.7308 77.6104C70.9562 77.6104 69.4455 77.2804 68.1988 76.6204C66.9668 75.9604 66.0282 75.0364 65.3828 73.8484C64.7375 72.6604 64.4148 71.2744 64.4148 69.6904C64.4148 68.4584 64.6055 67.3511 64.9868 66.3684C65.3828 65.3711 65.9475 64.5204 66.6808 63.8164C67.4142 63.0977 68.3088 62.5551 69.3648 62.1884C70.4355 61.8071 71.6455 61.6164 72.9948 61.6164C73.7282 61.6164 74.4762 61.6897 75.2388 61.8364C76.0015 61.9684 76.7495 62.2251 77.4828 62.6064C77.8642 62.7824 78.1208 63.0317 78.2528 63.3544C78.3995 63.6624 78.4435 63.9924 78.3848 64.3444C78.3408 64.6817 78.2162 64.9971 78.0108 65.2904C77.8202 65.5691 77.5562 65.7597 77.2188 65.8624C76.8815 65.9504 76.5002 65.8991 76.0748 65.7084C75.6348 65.5031 75.1582 65.3491 74.6448 65.2464C74.1315 65.1291 73.5888 65.0704 73.0168 65.0704C72.0342 65.0704 71.2128 65.2464 70.5528 65.5984C69.9075 65.9504 69.4235 66.4711 69.1008 67.1604C68.7782 67.8497 68.6168 68.6931 68.6168 69.6904C68.6168 71.1864 68.9835 72.3157 69.7168 73.0784C70.4502 73.8411 71.5355 74.2224 72.9728 74.2224C73.4128 74.2224 73.8895 74.1784 74.4028 74.0904C74.9308 74.0024 75.4588 73.8777 75.9868 73.7164L75.2388 75.2344V71.4724H73.6988C73.2002 71.4724 72.8115 71.3477 72.5328 71.0984C72.2688 70.8491 72.1368 70.4971 72.1368 70.0424C72.1368 69.5877 72.2688 69.2431 72.5328 69.0084C72.8115 68.7591 73.2002 68.6344 73.6988 68.6344H76.9548C77.4682 68.6344 77.8568 68.7737 78.1208 69.0524C78.3995 69.3164 78.5388 69.7051 78.5388 70.2184V75.0804C78.5388 75.5204 78.4435 75.8944 78.2528 76.2024C78.0768 76.5104 77.7908 76.7304 77.3948 76.8624C76.7055 77.0971 75.9575 77.2804 75.1508 77.4124C74.3442 77.5444 73.5375 77.6104 72.7308 77.6104Z"
							fill="#2A281E"
						/>
					</g>
					<g filter="url(#filter21_d_0_1)">
						<path
							d="M147 107.684C147 104.371 149.686 101.684 153 101.684H181.526C184.84 101.684 187.526 104.371 187.526 107.684V136.211C187.526 139.524 184.84 142.211 181.526 142.211H153C149.686 142.211 147 139.524 147 136.211V107.684Z"
							fill="#2A281E"
						/>
						<mask id="path-86-inside-22_0_1" fill="white">
							<path d="M147 104C147 100.686 149.686 98 153 98H181.526C184.84 98 187.526 100.686 187.526 104V132.526C187.526 135.84 184.84 138.526 181.526 138.526H153C149.686 138.526 147 135.84 147 132.526V104Z" />
						</mask>
						<path
							d="M147 104C147 100.686 149.686 98 153 98H181.526C184.84 98 187.526 100.686 187.526 104V132.526C187.526 135.84 184.84 138.526 181.526 138.526H153C149.686 138.526 147 135.84 147 132.526V104Z"
							fill="#c6b894"
							className="overlapped-tile-surface"
						/>
						<path
							d="M147 98H187.526H147ZM187.526 132.526C187.526 136.392 184.392 139.526 180.526 139.526H154C150.134 139.526 147 136.392 147 132.526C147 135.288 149.686 137.526 153 137.526H181.526C184.84 137.526 187.526 135.288 187.526 132.526ZM147 138.526V98V138.526ZM187.526 98V138.526V98Z"
							fill="#2A281E"
							mask="url(#path-86-inside-22_0_1)"
						/>
						<path
							d="M167.626 125.566C166.98 125.566 166.482 125.39 166.13 125.038C165.778 124.672 165.602 124.166 165.602 123.52V113.158H162.148C161.605 113.158 161.187 113.019 160.894 112.74C160.615 112.447 160.476 112.036 160.476 111.508C160.476 110.966 160.615 110.555 160.894 110.276C161.187 109.998 161.605 109.858 162.148 109.858H173.104C173.646 109.858 174.057 109.998 174.336 110.276C174.629 110.555 174.776 110.966 174.776 111.508C174.776 112.036 174.629 112.447 174.336 112.74C174.057 113.019 173.646 113.158 173.104 113.158H169.65V123.52C169.65 124.166 169.481 124.672 169.144 125.038C168.806 125.39 168.3 125.566 167.626 125.566Z"
							fill="#2A281E"
						/>
					</g>
					<g filter="url(#filter22_d_0_1)">
						<path
							d="M147 155.684C147 152.371 149.686 149.684 153 149.684H181.526C184.84 149.684 187.526 152.371 187.526 155.684V184.211C187.526 187.524 184.84 190.211 181.526 190.211H153C149.686 190.211 147 187.524 147 184.211V155.684Z"
							fill="#2A281E"
						/>
						<mask id="path-90-inside-23_0_1" fill="white">
							<path d="M147 152C147 148.686 149.686 146 153 146H181.526C184.84 146 187.526 148.686 187.526 152V180.526C187.526 183.84 184.84 186.526 181.526 186.526H153C149.686 186.526 147 183.84 147 180.526V152Z" />
						</mask>
						<path
							d="M147 152C147 148.686 149.686 146 153 146H181.526C184.84 146 187.526 148.686 187.526 152V180.526C187.526 183.84 184.84 186.526 181.526 186.526H153C149.686 186.526 147 183.84 147 180.526V152Z"
							fill="#c6b894"
							className="overlapped-tile-surface"
						/>
						<path
							d="M147 146H187.526H147ZM187.526 180.526C187.526 184.392 184.392 187.526 180.526 187.526H154C150.134 187.526 147 184.392 147 180.526C147 183.288 149.686 185.526 153 185.526H181.526C184.84 185.526 187.526 183.288 187.526 180.526ZM147 186.526V146V186.526ZM187.526 146V186.526V146Z"
							fill="#2A281E"
							mask="url(#path-90-inside-23_0_1)"
						/>
						<path
							d="M169.287 173.61C167.571 173.61 166.097 173.28 164.865 172.62C163.633 171.96 162.687 171.029 162.027 169.826C161.382 168.624 161.059 167.216 161.059 165.602C161.059 164.4 161.243 163.307 161.609 162.324C161.991 161.342 162.533 160.498 163.237 159.794C163.956 159.09 164.821 158.555 165.833 158.188C166.86 157.807 168.011 157.616 169.287 157.616C169.962 157.616 170.659 157.697 171.377 157.858C172.111 158.005 172.756 158.232 173.313 158.54C173.724 158.76 174.01 159.039 174.171 159.376C174.333 159.714 174.384 160.058 174.325 160.41C174.281 160.762 174.157 161.078 173.951 161.356C173.746 161.635 173.482 161.826 173.159 161.928C172.837 162.016 172.485 161.965 172.103 161.774C171.663 161.569 171.223 161.415 170.783 161.312C170.358 161.195 169.911 161.136 169.441 161.136C168.532 161.136 167.769 161.312 167.153 161.664C166.552 162.002 166.097 162.5 165.789 163.16C165.481 163.82 165.327 164.634 165.327 165.602C165.327 166.57 165.481 167.392 165.789 168.066C166.097 168.726 166.552 169.232 167.153 169.584C167.769 169.922 168.532 170.09 169.441 170.09C169.823 170.09 170.233 170.046 170.673 169.958C171.113 169.856 171.546 169.702 171.971 169.496C172.411 169.306 172.8 169.254 173.137 169.342C173.489 169.43 173.768 169.606 173.973 169.87C174.193 170.134 174.333 170.442 174.391 170.794C174.45 171.132 174.399 171.469 174.237 171.806C174.091 172.144 173.827 172.415 173.445 172.62C172.932 172.928 172.294 173.17 171.531 173.346C170.783 173.522 170.035 173.61 169.287 173.61Z"
							fill="#2A281E"
						/>
					</g>
					<g filter="url(#filter23_d_0_1)">
						<path
							d="M51 107.684C51 104.371 53.6863 101.684 57 101.684H85.5263C88.84 101.684 91.5263 104.371 91.5263 107.684V136.211C91.5263 139.524 88.84 142.211 85.5263 142.211H57C53.6863 142.211 51 139.524 51 136.211V107.684Z"
							fill="#2A281E"
						/>
						<mask id="path-94-inside-24_0_1" fill="white">
							<path d="M51 104C51 100.686 53.6863 98 57 98H85.5263C88.84 98 91.5263 100.686 91.5263 104V132.526C91.5263 135.84 88.84 138.526 85.5263 138.526H57C53.6863 138.526 51 135.84 51 132.526V104Z" />
						</mask>
						<path
							d="M51 104C51 100.686 53.6863 98 57 98H85.5263C88.84 98 91.5263 100.686 91.5263 104V132.526C91.5263 135.84 88.84 138.526 85.5263 138.526H57C53.6863 138.526 51 135.84 51 132.526V104Z"
							fill="#c6b894"
							className="overlapped-tile-surface"
						/>
						<path
							d="M51 98H91.5263H51ZM91.5263 132.526C91.5263 136.392 88.3923 139.526 84.5263 139.526H58C54.134 139.526 51 136.392 51 132.526C51 135.288 53.6863 137.526 57 137.526H85.5263C88.84 137.526 91.5263 135.288 91.5263 132.526ZM51 138.526V98V138.526ZM91.5263 98V138.526V98Z"
							fill="#2A281E"
							mask="url(#path-94-inside-24_0_1)"
						/>
						<path
							d="M66.5847 125.566C65.9687 125.566 65.4993 125.405 65.1767 125.082C64.854 124.76 64.6927 124.283 64.6927 123.652V111.662C64.6927 111.017 64.854 110.526 65.1767 110.188C65.4993 109.836 65.9247 109.66 66.4527 109.66C66.922 109.66 67.2887 109.748 67.5527 109.924C67.8167 110.1 68.11 110.394 68.4327 110.804L75.4067 119.516H74.7907V111.552C74.7907 110.936 74.9447 110.467 75.2527 110.144C75.5753 109.822 76.0447 109.66 76.6607 109.66C77.2767 109.66 77.7387 109.822 78.0467 110.144C78.3693 110.467 78.5307 110.936 78.5307 111.552V123.74C78.5307 124.298 78.384 124.745 78.0907 125.082C77.7973 125.405 77.4013 125.566 76.9027 125.566C76.404 125.566 76.008 125.478 75.7147 125.302C75.436 125.112 75.1353 124.818 74.8127 124.422L67.8387 115.688H68.4547V123.652C68.4547 124.283 68.2933 124.76 67.9707 125.082C67.6627 125.405 67.2007 125.566 66.5847 125.566Z"
							fill="#2A281E"
						/>
					</g>
					<g filter="url(#filter24_d_0_1)">
						<path
							d="M51 155.684C51 152.371 53.6863 149.684 57 149.684H85.5263C88.84 149.684 91.5263 152.371 91.5263 155.684V184.211C91.5263 187.524 88.84 190.211 85.5263 190.211H57C53.6863 190.211 51 187.524 51 184.211V155.684Z"
							fill="#2A281E"
						/>
						<mask id="path-98-inside-25_0_1" fill="white">
							<path d="M51 152C51 148.686 53.6863 146 57 146H85.5263C88.84 146 91.5263 148.686 91.5263 152V180.526C91.5263 183.84 88.84 186.526 85.5263 186.526H57C53.6863 186.526 51 183.84 51 180.526V152Z" />
						</mask>
						<path
							d="M51 152C51 148.686 53.6863 146 57 146H85.5263C88.84 146 91.5263 148.686 91.5263 152V180.526C91.5263 183.84 88.84 186.526 85.5263 186.526H57C53.6863 186.526 51 183.84 51 180.526V152Z"
							fill="#c6b894"
							className="overlapped-tile-surface"
						/>
						<path
							d="M51 146H91.5263H51ZM91.5263 180.526C91.5263 184.392 88.3923 187.526 84.5263 187.526H58C54.134 187.526 51 184.392 51 180.526C51 183.288 53.6863 185.526 57 185.526H85.5263C88.84 185.526 91.5263 183.288 91.5263 180.526ZM51 186.526V146V186.526ZM91.5263 146V186.526V146Z"
							fill="#2A281E"
							mask="url(#path-98-inside-25_0_1)"
						/>
						<path
							d="M68.3838 173.368C67.6944 173.368 67.1664 173.192 66.7998 172.84C66.4478 172.474 66.2718 171.953 66.2718 171.278V159.948C66.2718 159.274 66.4478 158.76 66.7998 158.408C67.1664 158.042 67.6944 157.858 68.3838 157.858H75.8418C76.3698 157.858 76.7658 157.99 77.0298 158.254C77.2938 158.518 77.4258 158.9 77.4258 159.398C77.4258 159.912 77.2938 160.308 77.0298 160.586C76.7658 160.85 76.3698 160.982 75.8418 160.982H70.1438V163.93H75.3578C75.8711 163.93 76.2598 164.062 76.5238 164.326C76.8024 164.59 76.9418 164.979 76.9418 165.492C76.9418 166.006 76.8024 166.394 76.5238 166.658C76.2598 166.922 75.8711 167.054 75.3578 167.054H70.1438V170.244H75.8418C76.3698 170.244 76.7658 170.384 77.0298 170.662C77.2938 170.926 77.4258 171.308 77.4258 171.806C77.4258 172.32 77.2938 172.708 77.0298 172.972C76.7658 173.236 76.3698 173.368 75.8418 173.368H68.3838Z"
							fill="#2A281E"
						/>
					</g>
					<g filter="url(#filter25_d_0_1)">
						<path
							d="M99 155.684C99 152.371 101.686 149.684 105 149.684H133.526C136.84 149.684 139.526 152.371 139.526 155.684V184.211C139.526 187.524 136.84 190.211 133.526 190.211H105C101.686 190.211 99 187.524 99 184.211V155.684Z"
							fill="#2A281E"
						/>
						<mask id="path-102-inside-26_0_1" fill="white">
							<path d="M99 152C99 148.686 101.686 146 105 146H133.526C136.84 146 139.526 148.686 139.526 152V180.526C139.526 183.84 136.84 186.526 133.526 186.526H105C101.686 186.526 99 183.84 99 180.526V152Z" />
						</mask>
						<path
							d="M99 152C99 148.686 101.686 146 105 146H133.526C136.84 146 139.526 148.686 139.526 152V180.526C139.526 183.84 136.84 186.526 133.526 186.526H105C101.686 186.526 99 183.84 99 180.526V152Z"
							fill="#c6b894"
							className="overlapped-tile-surface"
						/>
						<path
							d="M99 146H139.526H99ZM139.526 180.526C139.526 184.392 136.392 187.526 132.526 187.526H106C102.134 187.526 99 184.392 99 180.526C99 183.288 101.686 185.526 105 185.526H133.526C136.84 185.526 139.526 183.288 139.526 180.526ZM99 186.526V146V186.526ZM139.526 146V186.526V146Z"
							fill="#2A281E"
							mask="url(#path-102-inside-26_0_1)"
						/>
						<path
							d="M119.626 173.566C118.98 173.566 118.482 173.39 118.13 173.038C117.778 172.672 117.602 172.166 117.602 171.52V161.158H114.148C113.605 161.158 113.187 161.019 112.894 160.74C112.615 160.447 112.476 160.036 112.476 159.508C112.476 158.966 112.615 158.555 112.894 158.276C113.187 157.998 113.605 157.858 114.148 157.858H125.104C125.646 157.858 126.057 157.998 126.336 158.276C126.629 158.555 126.776 158.966 126.776 159.508C126.776 160.036 126.629 160.447 126.336 160.74C126.057 161.019 125.646 161.158 125.104 161.158H121.65V171.52C121.65 172.166 121.481 172.672 121.144 173.038C120.806 173.39 120.3 173.566 119.626 173.566Z"
							fill="#2A281E"
						/>
					</g>
					<g filter="url(#filter26_d_0_1)">
						<path
							d="M75 83.6843C75 80.3706 77.6863 77.6843 81 77.6843H109.526C112.84 77.6843 115.526 80.3706 115.526 83.6843V112.211C115.526 115.524 112.84 118.211 109.526 118.211H81C77.6863 118.211 75 115.524 75 112.211V83.6843Z"
							fill="#383524"
						/>
						<mask id="path-106-inside-27_0_1" fill="white">
							<path d="M75 80C75 76.6863 77.6863 74 81 74H109.526C112.84 74 115.526 76.6863 115.526 80V108.526C115.526 111.84 112.84 114.526 109.526 114.526H81C77.6863 114.526 75 111.84 75 108.526V80Z" />
						</mask>
						<path
							d="M75 80C75 76.6863 77.6863 74 81 74H109.526C112.84 74 115.526 76.6863 115.526 80V108.526C115.526 111.84 112.84 114.526 109.526 114.526H81C77.6863 114.526 75 111.84 75 108.526V80Z"
							fill="#F8F0DC"
							className="tile-surface"
						/>
						<path
							d="M75 74H115.526H75ZM115.526 108.526C115.526 112.392 112.392 115.526 108.526 115.526H82C78.134 115.526 75 112.392 75 108.526C75 111.288 77.6863 113.526 81 113.526H109.526C112.84 113.526 115.526 111.288 115.526 108.526ZM75 114.526V74V114.526ZM115.526 74V114.526V74Z"
							fill="#383524"
							mask="url(#path-106-inside-27_0_1)"
						/>
						<path
							d="M90.4052 101.566C89.7598 101.566 89.2612 101.39 88.9092 101.038C88.5572 100.672 88.3812 100.158 88.3812 99.4984V87.7284C88.3812 87.0537 88.5572 86.5404 88.9092 86.1884C89.2612 85.8364 89.7598 85.6604 90.4052 85.6604C91.0652 85.6604 91.5638 85.8364 91.9012 86.1884C92.2532 86.5404 92.4292 87.0537 92.4292 87.7284V91.8424H98.8312V87.7284C98.8312 87.0537 98.9998 86.5404 99.3372 86.1884C99.6892 85.8364 100.195 85.6604 100.855 85.6604C101.5 85.6604 101.992 85.8364 102.329 86.1884C102.681 86.5404 102.857 87.0537 102.857 87.7284V99.4984C102.857 100.158 102.681 100.672 102.329 101.038C101.992 101.39 101.5 101.566 100.855 101.566C100.195 101.566 99.6892 101.39 99.3372 101.038C98.9998 100.672 98.8312 100.158 98.8312 99.4984V95.1644H92.4292V99.4984C92.4292 100.158 92.2605 100.672 91.9232 101.038C91.5858 101.39 91.0798 101.566 90.4052 101.566Z"
							fill="#383524"
						/>
					</g>
					<g filter="url(#filter27_d_0_1)">
						<path
							d="M123 83.6843C123 80.3706 125.686 77.6843 129 77.6843H157.526C160.84 77.6843 163.526 80.3706 163.526 83.6843V112.211C163.526 115.524 160.84 118.211 157.526 118.211H129C125.686 118.211 123 115.524 123 112.211V83.6843Z"
							fill="#383524"
						/>
						<mask id="path-110-inside-28_0_1" fill="white">
							<path d="M123 80C123 76.6863 125.686 74 129 74H157.526C160.84 74 163.526 76.6863 163.526 80V108.526C163.526 111.84 160.84 114.526 157.526 114.526H129C125.686 114.526 123 111.84 123 108.526V80Z" />
						</mask>
						<path
							d="M123 80C123 76.6863 125.686 74 129 74H157.526C160.84 74 163.526 76.6863 163.526 80V108.526C163.526 111.84 160.84 114.526 157.526 114.526H129C125.686 114.526 123 111.84 123 108.526V80Z"
							fill="#F8F0DC"
							className="tile-surface"
						/>
						<path
							d="M123 74H163.526H123ZM163.526 108.526C163.526 112.392 160.392 115.526 156.526 115.526H130C126.134 115.526 123 112.392 123 108.526C123 111.288 125.686 113.526 129 113.526H157.526C160.84 113.526 163.526 111.288 163.526 108.526ZM123 114.526V74V114.526ZM163.526 74V114.526V74Z"
							fill="#383524"
							mask="url(#path-110-inside-28_0_1)"
						/>
						<path
							d="M137.177 101.566C136.59 101.566 136.136 101.405 135.813 101.082C135.505 100.76 135.351 100.305 135.351 99.7184V87.5084C135.351 86.9071 135.52 86.4524 135.857 86.1444C136.194 85.8217 136.671 85.6604 137.287 85.6604C137.8 85.6604 138.204 85.7631 138.497 85.9684C138.805 86.1591 139.084 86.4817 139.333 86.9364L144.063 95.4284H143.293L148.001 86.9364C148.265 86.4817 148.544 86.1591 148.837 85.9684C149.145 85.7631 149.556 85.6604 150.069 85.6604C150.656 85.6604 151.103 85.8217 151.411 86.1444C151.734 86.4524 151.895 86.9071 151.895 87.5084V99.7184C151.895 100.305 151.741 100.76 151.433 101.082C151.125 101.405 150.67 101.566 150.069 101.566C149.482 101.566 149.028 101.405 148.705 101.082C148.397 100.76 148.243 100.305 148.243 99.7184V92.1504H148.705L145.163 98.3104C144.958 98.6331 144.738 98.8751 144.503 99.0364C144.283 99.1977 143.982 99.2784 143.601 99.2784C143.234 99.2784 142.934 99.1977 142.699 99.0364C142.464 98.8751 142.252 98.6331 142.061 98.3104L138.497 92.1284H139.003V99.7184C139.003 100.305 138.849 100.76 138.541 101.082C138.233 101.405 137.778 101.566 137.177 101.566Z"
							fill="#383524"
						/>
					</g>
					<g filter="url(#filter28_d_0_1)">
						<path
							d="M123 131.684C123 128.371 125.686 125.684 129 125.684H157.526C160.84 125.684 163.526 128.371 163.526 131.684V160.211C163.526 163.524 160.84 166.211 157.526 166.211H129C125.686 166.211 123 163.524 123 160.211V131.684Z"
							fill="#383524"
						/>
						<mask id="path-114-inside-29_0_1" fill="white">
							<path d="M123 128C123 124.686 125.686 122 129 122H157.526C160.84 122 163.526 124.686 163.526 128V156.526C163.526 159.84 160.84 162.526 157.526 162.526H129C125.686 162.526 123 159.84 123 156.526V128Z" />
						</mask>
						<path
							d="M123 128C123 124.686 125.686 122 129 122H157.526C160.84 122 163.526 124.686 163.526 128V156.526C163.526 159.84 160.84 162.526 157.526 162.526H129C125.686 162.526 123 159.84 123 156.526V128Z"
							fill="#F8F0DC"
							className="tile-surface"
						/>
						<path
							d="M123 122H163.526H123ZM163.526 156.526C163.526 160.392 160.392 163.526 156.526 163.526H130C126.134 163.526 123 160.392 123 156.526C123 159.288 125.686 161.526 129 161.526H157.526C160.84 161.526 163.526 159.288 163.526 156.526ZM123 162.526V122V162.526ZM163.526 122V162.526V122Z"
							fill="#383524"
							mask="url(#path-114-inside-29_0_1)"
						/>
						<path
							d="M144.731 149.61C142.956 149.61 141.446 149.28 140.199 148.62C138.967 147.96 138.028 147.036 137.383 145.848C136.738 144.66 136.415 143.274 136.415 141.69C136.415 140.458 136.606 139.351 136.987 138.368C137.383 137.371 137.948 136.52 138.681 135.816C139.414 135.098 140.309 134.555 141.365 134.188C142.436 133.807 143.646 133.616 144.995 133.616C145.728 133.616 146.476 133.69 147.239 133.836C148.002 133.968 148.75 134.225 149.483 134.606C149.864 134.782 150.121 135.032 150.253 135.354C150.4 135.662 150.444 135.992 150.385 136.344C150.341 136.682 150.216 136.997 150.011 137.29C149.82 137.569 149.556 137.76 149.219 137.862C148.882 137.95 148.5 137.899 148.075 137.708C147.635 137.503 147.158 137.349 146.645 137.246C146.132 137.129 145.589 137.07 145.017 137.07C144.034 137.07 143.213 137.246 142.553 137.598C141.908 137.95 141.424 138.471 141.101 139.16C140.778 139.85 140.617 140.693 140.617 141.69C140.617 143.186 140.984 144.316 141.717 145.078C142.45 145.841 143.536 146.222 144.973 146.222C145.413 146.222 145.89 146.178 146.403 146.09C146.931 146.002 147.459 145.878 147.987 145.716L147.239 147.234V143.472H145.699C145.2 143.472 144.812 143.348 144.533 143.098C144.269 142.849 144.137 142.497 144.137 142.042C144.137 141.588 144.269 141.243 144.533 141.008C144.812 140.759 145.2 140.634 145.699 140.634H148.955C149.468 140.634 149.857 140.774 150.121 141.052C150.4 141.316 150.539 141.705 150.539 142.218V147.08C150.539 147.52 150.444 147.894 150.253 148.202C150.077 148.51 149.791 148.73 149.395 148.862C148.706 149.097 147.958 149.28 147.151 149.412C146.344 149.544 145.538 149.61 144.731 149.61Z"
							fill="#383524"
						/>
					</g>
					<g filter="url(#filter29_d_0_1)">
						<path
							d="M75 131.684C75 128.371 77.6863 125.684 81 125.684H109.526C112.84 125.684 115.526 128.371 115.526 131.684V160.211C115.526 163.524 112.84 166.211 109.526 166.211H81C77.6863 166.211 75 163.524 75 160.211V131.684Z"
							fill="#2A281E"
						/>
						<mask id="path-118-inside-30_0_1" fill="white">
							<path d="M75 128C75 124.686 77.6863 122 81 122H109.526C112.84 122 115.526 124.686 115.526 128V156.526C115.526 159.84 112.84 162.526 109.526 162.526H81C77.6863 162.526 75 159.84 75 156.526V128Z" />
						</mask>
						<path
							d="M75 128C75 124.686 77.6863 122 81 122H109.526C112.84 122 115.526 124.686 115.526 128V156.526C115.526 159.84 112.84 162.526 109.526 162.526H81C77.6863 162.526 75 159.84 75 156.526V128Z"
							fill="#F8F0DC"
							className="tile-surface"
						/>
						<path
							d="M75 122H115.526H75ZM115.526 156.526C115.526 160.392 112.392 163.526 108.526 163.526H82C78.134 163.526 75 160.392 75 156.526C75 159.288 77.6863 161.526 81 161.526H109.526C112.84 161.526 115.526 159.288 115.526 156.526ZM75 162.526V122V162.526ZM115.526 122V162.526V122Z"
							fill="#2A281E"
							mask="url(#path-118-inside-30_0_1)"
						/>
						<path
							d="M91.417 149.368C90.7276 149.368 90.1996 149.192 89.833 148.84C89.481 148.474 89.305 147.953 89.305 147.278V135.948C89.305 135.274 89.481 134.76 89.833 134.408C90.1996 134.042 90.7276 133.858 91.417 133.858H96.785C97.8996 133.858 98.8456 134.027 99.623 134.364C100.415 134.687 101.016 135.149 101.427 135.75C101.838 136.352 102.043 137.056 102.043 137.862C102.043 138.772 101.779 139.549 101.251 140.194C100.738 140.84 100.034 141.28 99.139 141.514V141.162C100.195 141.353 101.009 141.778 101.581 142.438C102.168 143.098 102.461 143.942 102.461 144.968C102.461 146.332 101.97 147.41 100.987 148.202C100.019 148.98 98.6916 149.368 97.005 149.368H91.417ZM93.177 146.398H96.455C97.203 146.398 97.7456 146.259 98.083 145.98C98.435 145.687 98.611 145.254 98.611 144.682C98.611 144.11 98.435 143.685 98.083 143.406C97.7456 143.128 97.203 142.988 96.455 142.988H93.177V146.398ZM93.177 140.018H96.059C96.7923 140.018 97.3276 139.886 97.665 139.622C98.017 139.358 98.193 138.955 98.193 138.412C98.193 137.87 98.017 137.474 97.665 137.224C97.3276 136.96 96.7923 136.828 96.059 136.828H93.177V140.018Z"
							fill="#2A281E"
						/>
					</g>
					<defs>
						<filter
							id="filter0_d_0_1"
							x="144"
							y="0"
							width="48.5264"
							height="52.2107"
							filterUnits="userSpaceOnUse"
							colorInterpolationFilters="sRGB"
						>
							<feFlood flood-opacity="0" result="BackgroundImageFix" />
							<feColorMatrix
								in="SourceAlpha"
								type="matrix"
								values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
								result="hardAlpha"
							/>
							<feOffset dx="1" dy="2" />
							<feGaussianBlur stdDeviation="2" />
							<feComposite in2="hardAlpha" operator="out" />
							<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
							<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_0_1" />
							<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_0_1" result="shape" />
						</filter>
						<filter
							id="filter1_d_0_1"
							x="192"
							y="48"
							width="48.5264"
							height="52.2107"
							filterUnits="userSpaceOnUse"
							colorInterpolationFilters="sRGB"
						>
							<feFlood flood-opacity="0" result="BackgroundImageFix" />
							<feColorMatrix
								in="SourceAlpha"
								type="matrix"
								values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
								result="hardAlpha"
							/>
							<feOffset dx="1" dy="2" />
							<feGaussianBlur stdDeviation="2" />
							<feComposite in2="hardAlpha" operator="out" />
							<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
							<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_0_1" />
							<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_0_1" result="shape" />
						</filter>
						<filter
							id="filter2_d_0_1"
							x="0"
							y="48"
							width="48.5264"
							height="52.2107"
							filterUnits="userSpaceOnUse"
							colorInterpolationFilters="sRGB"
						>
							<feFlood flood-opacity="0" result="BackgroundImageFix" />
							<feColorMatrix
								in="SourceAlpha"
								type="matrix"
								values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
								result="hardAlpha"
							/>
							<feOffset dx="1" dy="2" />
							<feGaussianBlur stdDeviation="2" />
							<feComposite in2="hardAlpha" operator="out" />
							<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
							<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_0_1" />
							<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_0_1" result="shape" />
						</filter>
						<filter
							id="filter3_d_0_1"
							x="48"
							y="0"
							width="48.5264"
							height="52.2107"
							filterUnits="userSpaceOnUse"
							colorInterpolationFilters="sRGB"
						>
							<feFlood flood-opacity="0" result="BackgroundImageFix" />
							<feColorMatrix
								in="SourceAlpha"
								type="matrix"
								values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
								result="hardAlpha"
							/>
							<feOffset dx="1" dy="2" />
							<feGaussianBlur stdDeviation="2" />
							<feComposite in2="hardAlpha" operator="out" />
							<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
							<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_0_1" />
							<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_0_1" result="shape" />
						</filter>
						<filter
							id="filter4_d_0_1"
							x="192"
							y="96"
							width="48.5264"
							height="52.2107"
							filterUnits="userSpaceOnUse"
							colorInterpolationFilters="sRGB"
						>
							<feFlood flood-opacity="0" result="BackgroundImageFix" />
							<feColorMatrix
								in="SourceAlpha"
								type="matrix"
								values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
								result="hardAlpha"
							/>
							<feOffset dx="1" dy="2" />
							<feGaussianBlur stdDeviation="2" />
							<feComposite in2="hardAlpha" operator="out" />
							<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
							<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_0_1" />
							<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_0_1" result="shape" />
						</filter>
						<filter
							id="filter5_d_0_1"
							x="144"
							y="192"
							width="48.5264"
							height="52.2107"
							filterUnits="userSpaceOnUse"
							colorInterpolationFilters="sRGB"
						>
							<feFlood flood-opacity="0" result="BackgroundImageFix" />
							<feColorMatrix
								in="SourceAlpha"
								type="matrix"
								values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
								result="hardAlpha"
							/>
							<feOffset dx="1" dy="2" />
							<feGaussianBlur stdDeviation="2" />
							<feComposite in2="hardAlpha" operator="out" />
							<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
							<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_0_1" />
							<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_0_1" result="shape" />
						</filter>
						<filter
							id="filter6_d_0_1"
							x="192"
							y="144"
							width="48.5264"
							height="52.2107"
							filterUnits="userSpaceOnUse"
							colorInterpolationFilters="sRGB"
						>
							<feFlood flood-opacity="0" result="BackgroundImageFix" />
							<feColorMatrix
								in="SourceAlpha"
								type="matrix"
								values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
								result="hardAlpha"
							/>
							<feOffset dx="1" dy="2" />
							<feGaussianBlur stdDeviation="2" />
							<feComposite in2="hardAlpha" operator="out" />
							<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
							<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_0_1" />
							<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_0_1" result="shape" />
						</filter>
						<filter
							id="filter7_d_0_1"
							x="0"
							y="96"
							width="48.5264"
							height="52.2107"
							filterUnits="userSpaceOnUse"
							colorInterpolationFilters="sRGB"
						>
							<feFlood flood-opacity="0" result="BackgroundImageFix" />
							<feColorMatrix
								in="SourceAlpha"
								type="matrix"
								values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
								result="hardAlpha"
							/>
							<feOffset dx="1" dy="2" />
							<feGaussianBlur stdDeviation="2" />
							<feComposite in2="hardAlpha" operator="out" />
							<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
							<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_0_1" />
							<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_0_1" result="shape" />
						</filter>
						<filter
							id="filter8_d_0_1"
							x="0"
							y="144"
							width="48.5264"
							height="52.2107"
							filterUnits="userSpaceOnUse"
							colorInterpolationFilters="sRGB"
						>
							<feFlood flood-opacity="0" result="BackgroundImageFix" />
							<feColorMatrix
								in="SourceAlpha"
								type="matrix"
								values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
								result="hardAlpha"
							/>
							<feOffset dx="1" dy="2" />
							<feGaussianBlur stdDeviation="2" />
							<feComposite in2="hardAlpha" operator="out" />
							<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
							<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_0_1" />
							<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_0_1" result="shape" />
						</filter>
						<filter
							id="filter9_d_0_1"
							x="48"
							y="192"
							width="48.5264"
							height="52.2107"
							filterUnits="userSpaceOnUse"
							colorInterpolationFilters="sRGB"
						>
							<feFlood flood-opacity="0" result="BackgroundImageFix" />
							<feColorMatrix
								in="SourceAlpha"
								type="matrix"
								values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
								result="hardAlpha"
							/>
							<feOffset dx="1" dy="2" />
							<feGaussianBlur stdDeviation="2" />
							<feComposite in2="hardAlpha" operator="out" />
							<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
							<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_0_1" />
							<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_0_1" result="shape" />
						</filter>
						<filter
							id="filter10_d_0_1"
							x="168"
							y="72"
							width="48.5264"
							height="52.2107"
							filterUnits="userSpaceOnUse"
							colorInterpolationFilters="sRGB"
						>
							<feFlood flood-opacity="0" result="BackgroundImageFix" />
							<feColorMatrix
								in="SourceAlpha"
								type="matrix"
								values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
								result="hardAlpha"
							/>
							<feOffset dx="1" dy="2" />
							<feGaussianBlur stdDeviation="2" />
							<feComposite in2="hardAlpha" operator="out" />
							<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
							<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_0_1" />
							<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_0_1" result="shape" />
						</filter>
						<filter
							id="filter11_d_0_1"
							x="24"
							y="72"
							width="48.5264"
							height="52.2107"
							filterUnits="userSpaceOnUse"
							colorInterpolationFilters="sRGB"
						>
							<feFlood flood-opacity="0" result="BackgroundImageFix" />
							<feColorMatrix
								in="SourceAlpha"
								type="matrix"
								values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
								result="hardAlpha"
							/>
							<feOffset dx="1" dy="2" />
							<feGaussianBlur stdDeviation="2" />
							<feComposite in2="hardAlpha" operator="out" />
							<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
							<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_0_1" />
							<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_0_1" result="shape" />
						</filter>
						<filter
							id="filter12_d_0_1"
							x="120"
							y="24"
							width="48.5264"
							height="52.2107"
							filterUnits="userSpaceOnUse"
							colorInterpolationFilters="sRGB"
						>
							<feFlood flood-opacity="0" result="BackgroundImageFix" />
							<feColorMatrix
								in="SourceAlpha"
								type="matrix"
								values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
								result="hardAlpha"
							/>
							<feOffset dx="1" dy="2" />
							<feGaussianBlur stdDeviation="2" />
							<feComposite in2="hardAlpha" operator="out" />
							<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
							<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_0_1" />
							<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_0_1" result="shape" />
						</filter>
						<filter
							id="filter13_d_0_1"
							x="72"
							y="24"
							width="48.5264"
							height="52.2107"
							filterUnits="userSpaceOnUse"
							colorInterpolationFilters="sRGB"
						>
							<feFlood flood-opacity="0" result="BackgroundImageFix" />
							<feColorMatrix
								in="SourceAlpha"
								type="matrix"
								values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
								result="hardAlpha"
							/>
							<feOffset dx="1" dy="2" />
							<feGaussianBlur stdDeviation="2" />
							<feComposite in2="hardAlpha" operator="out" />
							<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
							<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_0_1" />
							<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_0_1" result="shape" />
						</filter>
						<filter
							id="filter14_d_0_1"
							x="120"
							y="168"
							width="48.5264"
							height="52.2107"
							filterUnits="userSpaceOnUse"
							colorInterpolationFilters="sRGB"
						>
							<feFlood flood-opacity="0" result="BackgroundImageFix" />
							<feColorMatrix
								in="SourceAlpha"
								type="matrix"
								values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
								result="hardAlpha"
							/>
							<feOffset dx="1" dy="2" />
							<feGaussianBlur stdDeviation="2" />
							<feComposite in2="hardAlpha" operator="out" />
							<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
							<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_0_1" />
							<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_0_1" result="shape" />
						</filter>
						<filter
							id="filter15_d_0_1"
							x="72"
							y="168"
							width="48.5264"
							height="52.2107"
							filterUnits="userSpaceOnUse"
							colorInterpolationFilters="sRGB"
						>
							<feFlood flood-opacity="0" result="BackgroundImageFix" />
							<feColorMatrix
								in="SourceAlpha"
								type="matrix"
								values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
								result="hardAlpha"
							/>
							<feOffset dx="1" dy="2" />
							<feGaussianBlur stdDeviation="2" />
							<feComposite in2="hardAlpha" operator="out" />
							<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
							<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_0_1" />
							<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_0_1" result="shape" />
						</filter>
						<filter
							id="filter16_d_0_1"
							x="168"
							y="120"
							width="48.5264"
							height="52.2107"
							filterUnits="userSpaceOnUse"
							colorInterpolationFilters="sRGB"
						>
							<feFlood flood-opacity="0" result="BackgroundImageFix" />
							<feColorMatrix
								in="SourceAlpha"
								type="matrix"
								values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
								result="hardAlpha"
							/>
							<feOffset dx="1" dy="2" />
							<feGaussianBlur stdDeviation="2" />
							<feComposite in2="hardAlpha" operator="out" />
							<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
							<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_0_1" />
							<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_0_1" result="shape" />
						</filter>
						<filter
							id="filter17_d_0_1"
							x="24"
							y="120"
							width="48.5264"
							height="52.2107"
							filterUnits="userSpaceOnUse"
							colorInterpolationFilters="sRGB"
						>
							<feFlood flood-opacity="0" result="BackgroundImageFix" />
							<feColorMatrix
								in="SourceAlpha"
								type="matrix"
								values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
								result="hardAlpha"
							/>
							<feOffset dx="1" dy="2" />
							<feGaussianBlur stdDeviation="2" />
							<feComposite in2="hardAlpha" operator="out" />
							<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
							<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_0_1" />
							<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_0_1" result="shape" />
						</filter>
						<filter
							id="filter18_d_0_1"
							x="144"
							y="48"
							width="48.5264"
							height="52.2107"
							filterUnits="userSpaceOnUse"
							colorInterpolationFilters="sRGB"
						>
							<feFlood flood-opacity="0" result="BackgroundImageFix" />
							<feColorMatrix
								in="SourceAlpha"
								type="matrix"
								values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
								result="hardAlpha"
							/>
							<feOffset dx="1" dy="2" />
							<feGaussianBlur stdDeviation="2" />
							<feComposite in2="hardAlpha" operator="out" />
							<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
							<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_0_1" />
							<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_0_1" result="shape" />
						</filter>
						<filter
							id="filter19_d_0_1"
							x="96"
							y="48"
							width="48.5264"
							height="52.2107"
							filterUnits="userSpaceOnUse"
							colorInterpolationFilters="sRGB"
						>
							<feFlood flood-opacity="0" result="BackgroundImageFix" />
							<feColorMatrix
								in="SourceAlpha"
								type="matrix"
								values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
								result="hardAlpha"
							/>
							<feOffset dx="1" dy="2" />
							<feGaussianBlur stdDeviation="2" />
							<feComposite in2="hardAlpha" operator="out" />
							<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
							<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_0_1" />
							<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_0_1" result="shape" />
						</filter>
						<filter
							id="filter20_d_0_1"
							x="48"
							y="48"
							width="48.5264"
							height="52.2107"
							filterUnits="userSpaceOnUse"
							colorInterpolationFilters="sRGB"
						>
							<feFlood flood-opacity="0" result="BackgroundImageFix" />
							<feColorMatrix
								in="SourceAlpha"
								type="matrix"
								values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
								result="hardAlpha"
							/>
							<feOffset dx="1" dy="2" />
							<feGaussianBlur stdDeviation="2" />
							<feComposite in2="hardAlpha" operator="out" />
							<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
							<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_0_1" />
							<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_0_1" result="shape" />
						</filter>
						<filter
							id="filter21_d_0_1"
							x="144"
							y="96"
							width="48.5264"
							height="52.2107"
							filterUnits="userSpaceOnUse"
							colorInterpolationFilters="sRGB"
						>
							<feFlood flood-opacity="0" result="BackgroundImageFix" />
							<feColorMatrix
								in="SourceAlpha"
								type="matrix"
								values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
								result="hardAlpha"
							/>
							<feOffset dx="1" dy="2" />
							<feGaussianBlur stdDeviation="2" />
							<feComposite in2="hardAlpha" operator="out" />
							<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
							<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_0_1" />
							<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_0_1" result="shape" />
						</filter>
						<filter
							id="filter22_d_0_1"
							x="144"
							y="144"
							width="48.5264"
							height="52.2107"
							filterUnits="userSpaceOnUse"
							colorInterpolationFilters="sRGB"
						>
							<feFlood flood-opacity="0" result="BackgroundImageFix" />
							<feColorMatrix
								in="SourceAlpha"
								type="matrix"
								values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
								result="hardAlpha"
							/>
							<feOffset dx="1" dy="2" />
							<feGaussianBlur stdDeviation="2" />
							<feComposite in2="hardAlpha" operator="out" />
							<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
							<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_0_1" />
							<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_0_1" result="shape" />
						</filter>
						<filter
							id="filter23_d_0_1"
							x="48"
							y="96"
							width="48.5264"
							height="52.2107"
							filterUnits="userSpaceOnUse"
							colorInterpolationFilters="sRGB"
						>
							<feFlood flood-opacity="0" result="BackgroundImageFix" />
							<feColorMatrix
								in="SourceAlpha"
								type="matrix"
								values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
								result="hardAlpha"
							/>
							<feOffset dx="1" dy="2" />
							<feGaussianBlur stdDeviation="2" />
							<feComposite in2="hardAlpha" operator="out" />
							<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
							<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_0_1" />
							<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_0_1" result="shape" />
						</filter>
						<filter
							id="filter24_d_0_1"
							x="48"
							y="144"
							width="48.5264"
							height="52.2107"
							filterUnits="userSpaceOnUse"
							colorInterpolationFilters="sRGB"
						>
							<feFlood flood-opacity="0" result="BackgroundImageFix" />
							<feColorMatrix
								in="SourceAlpha"
								type="matrix"
								values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
								result="hardAlpha"
							/>
							<feOffset dx="1" dy="2" />
							<feGaussianBlur stdDeviation="2" />
							<feComposite in2="hardAlpha" operator="out" />
							<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
							<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_0_1" />
							<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_0_1" result="shape" />
						</filter>
						<filter
							id="filter25_d_0_1"
							x="96"
							y="144"
							width="48.5264"
							height="52.2107"
							filterUnits="userSpaceOnUse"
							colorInterpolationFilters="sRGB"
						>
							<feFlood flood-opacity="0" result="BackgroundImageFix" />
							<feColorMatrix
								in="SourceAlpha"
								type="matrix"
								values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
								result="hardAlpha"
							/>
							<feOffset dx="1" dy="2" />
							<feGaussianBlur stdDeviation="2" />
							<feComposite in2="hardAlpha" operator="out" />
							<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
							<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_0_1" />
							<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_0_1" result="shape" />
						</filter>
						<filter
							id="filter26_d_0_1"
							x="72"
							y="72"
							width="48.5264"
							height="52.2107"
							filterUnits="userSpaceOnUse"
							colorInterpolationFilters="sRGB"
						>
							<feFlood flood-opacity="0" result="BackgroundImageFix" />
							<feColorMatrix
								in="SourceAlpha"
								type="matrix"
								values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
								result="hardAlpha"
							/>
							<feOffset dx="1" dy="2" />
							<feGaussianBlur stdDeviation="2" />
							<feComposite in2="hardAlpha" operator="out" />
							<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
							<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_0_1" />
							<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_0_1" result="shape" />
						</filter>
						<filter
							id="filter27_d_0_1"
							x="120"
							y="72"
							width="48.5264"
							height="52.2107"
							filterUnits="userSpaceOnUse"
							colorInterpolationFilters="sRGB"
						>
							<feFlood flood-opacity="0" result="BackgroundImageFix" />
							<feColorMatrix
								in="SourceAlpha"
								type="matrix"
								values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
								result="hardAlpha"
							/>
							<feOffset dx="1" dy="2" />
							<feGaussianBlur stdDeviation="2" />
							<feComposite in2="hardAlpha" operator="out" />
							<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
							<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_0_1" />
							<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_0_1" result="shape" />
						</filter>
						<filter
							id="filter28_d_0_1"
							x="120"
							y="120"
							width="48.5264"
							height="52.2107"
							filterUnits="userSpaceOnUse"
							colorInterpolationFilters="sRGB"
						>
							<feFlood flood-opacity="0" result="BackgroundImageFix" />
							<feColorMatrix
								in="SourceAlpha"
								type="matrix"
								values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
								result="hardAlpha"
							/>
							<feOffset dx="1" dy="2" />
							<feGaussianBlur stdDeviation="2" />
							<feComposite in2="hardAlpha" operator="out" />
							<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
							<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_0_1" />
							<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_0_1" result="shape" />
						</filter>
						<filter
							id="filter29_d_0_1"
							x="72"
							y="120"
							width="48.5264"
							height="52.2107"
							filterUnits="userSpaceOnUse"
							colorInterpolationFilters="sRGB"
						>
							<feFlood flood-opacity="0" result="BackgroundImageFix" />
							<feColorMatrix
								in="SourceAlpha"
								type="matrix"
								values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
								result="hardAlpha"
							/>
							<feOffset dx="1" dy="2" />
							<feGaussianBlur stdDeviation="2" />
							<feComposite in2="hardAlpha" operator="out" />
							<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
							<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_0_1" />
							<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_0_1" result="shape" />
						</filter>
					</defs>
				</svg>
			</a>
		</div>
	)
}

export default Stackdown
